module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "prodSettBG"
    }
  }, [_c('div', {
    staticClass: "ui container",
    attrs: {
      "id": "prodSetP"
    }
  }, [_c('p', [_vm._v(" ")]), _vm._v(" "), _c('h1', {
    staticClass: "ui inverted grey header",
    staticStyle: {
      "position": "relative",
      "text-shadow": "#333 1px 2px 3px"
    }
  }, [_c('i', {
    staticClass: "cogs icon"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "small ui compact button",
    staticStyle: {
      "position": "absolute",
      "right": "0px",
      "top": "12px"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push(_vm.$root.defaultPath)
      }
    }
  }, [_c('i', {
    staticClass: "left chevron icon"
  }), _vm._v("Back")])]), _vm._v(" "), _c('div', {
    staticClass: "ui padded segment"
  }, [(_vm.message) ? _c('div', {
    staticClass: "ui success message"
  }, [_c('i', {
    staticClass: "close icon",
    on: {
      "click": function($event) {
        _vm.message = ''
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("\n            " + _vm._s(_vm.message) + "\n          ")])]) : (_vm.error) ? _c('div', {
    staticClass: "ui error message"
  }, [_c('i', {
    staticClass: "close icon",
    on: {
      "click": function($event) {
        _vm.error = ''
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("Error")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.error))])]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "ui form"
  }, [_c('div', {
    staticClass: "ui two column stackable padded grid"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "ui two column centered grid",
    staticStyle: {
      "margin-top": "-1rem"
    }
  }, [_c('div', {
    staticClass: "four wide"
  }, [(_vm.isOwner) ? _c('button', {
    staticClass: "ui labeled icon button borderButton",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showAddSellerAccountModal
    }
  }, [_c('i', {
    staticClass: "add circle icon"
  }), _vm._v("Add Storefront (Seller ID)")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "two wide column"
  }, [_c('h4', {
    class: _vm.sellersDirty ? 'changed-color' : ''
  }, [_vm._v("Seller Accounts")])]), _vm._v(" "), (!_vm.isEmptyObject(_vm.sellers)) ? _c('div', {
    staticClass: "twelve wide column"
  }, [_c('table', {
    staticClass: "ui very basic compact table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "three wide"
  }, [_vm._v("Seller ID")]), _vm._v(" "), _c('th', {
    staticClass: "one wide"
  }, [_vm._v("Region")]), _vm._v(" "), _c('th', {
    staticClass: "four wide"
  }, [_vm._v("Account nick name")]), _vm._v(" "), _c('th', {
    staticClass: "three wide"
  }, [_vm._v("Auth Token")]), _vm._v(" "), (_vm.showAdvertisementApiSettings) ? _c('th', {
    staticClass: "two wide",
    attrs: {
      "data-tooltip": "Advertisement spending data is used by the Profit Dashboard"
    }
  }, [_vm._v("Connect to Ad API")]) : _vm._e(), _vm._v(" "), (_vm.anyAccountMayNeedReAuthorization) ? _c('th', {
    staticClass: "one wide"
  }) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "one wide"
  }, [_vm._v("Re-Authorize")]), _vm._v(" "), (_vm.isOwner) ? _c('th', {
    staticClass: "one wide"
  }, [_vm._v("Delete")]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredSellers), function(s) {
    return _c('seller-account', {
      key: s.sellerId.value,
      ref: "sellerAccounts",
      refInFor: true,
      attrs: {
        "seller": s,
        "showAdvertisementApiSettings": _vm.showAdvertisementApiSettings,
        "anyAccountMayNeedReAuthorization": _vm.anyAccountMayNeedReAuthorization,
        "isOwner": _vm.isOwner
      },
      on: {
        "account-changed": _vm.onSellerAccountChanged,
        "sellerAccountDeleted": _vm.sellerAccountDeleted
      }
    })
  }), 1)])]) : _c('div', {
    staticClass: "twelve wide column"
  }, [_c('i', [_vm._v("No seller accounts found")])])]), _vm._v(" "), _c('div', {
    staticClass: "ui container"
  }, [_c('div', {
    staticClass: "ui clearing"
  }, [_c('button', {
    class: _vm.dirty ? 'ui right floated primary button' : 'ui right floated primary disabled button',
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOwner),
      expression: "isOwner"
    }],
    staticClass: "row marginBotton-1 margin-top-2"
  }, [_vm._m(3)]), _vm._v(" "), (_vm.successMessage) ? _c('div', {
    staticClass: "row centered"
  }, [_c('div', {
    staticClass: "ui positive message transition",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n                " + _vm._s(_vm.successMessage) + "\n              ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOwner),
      expression: "isOwner"
    }],
    staticClass: "ui column centered grid",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "column row sub-heading"
  }, [_vm._v("View, manage, or add/deactivate users")]), _vm._v(" "), _c('div', {
    staticClass: "four column centered row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('button', {
    staticClass: "ui labeled icon button borderButton",
    staticStyle: {
      "width": "180px !important"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showAddUserModal
    }
  }, [_c('i', {
    staticClass: "add circle icon"
  }), _vm._v("Add User")])]), _vm._v(" "), (!_vm.showAllUsers) ? _c('div', {
    staticClass: "column"
  }, [_c('button', {
    staticClass: "ui labeled icon button borderButton",
    staticStyle: {
      "padding-left": "3.071em !important",
      "width": "180px !important"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleViewUser
    }
  }, [_c('i', {
    staticClass: "eye icon"
  }), _vm._v("View All Users")])]) : _c('div', {
    staticClass: "column"
  }, [_c('button', {
    staticClass: "ui labeled icon button borderButton",
    staticStyle: {
      "padding-left": "3.071em !important",
      "width": "180px !important"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleViewUser
    }
  }, [_c('i', {
    staticClass: "eye slash outline icon"
  }), _vm._v("Hide All Users")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('button', {
    staticClass: "ui labeled icon button borderButton",
    staticStyle: {
      "padding-left": "3.071em !important",
      "width": "180px !important"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showDeactivateUserModal
    }
  }, [_c('i', {
    staticClass: "trash alternate outline icon"
  }), _vm._v("Deactivate Users")])])])]), _vm._v(" "), (_vm.showAllUsers) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "two wide column"
  }), _vm._v(" "), _c('div', {
    staticClass: "fourteen wide column"
  }, [_c('table', {
    staticClass: "ui very basic table emailSettingsTable"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', [(_vm.tenantUsersLoading && _vm.tenantUsers.length === 0) ? _c('tr', [_c('td', {
    staticClass: "disabled",
    staticStyle: {
      "text-align": "center",
      "padding": "1.5em"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("\n                        Loading users…\n                      ")])]) : [_vm._l((_vm.manageUsersTableRows), function(row) {
    return _c('tr', {
      key: 'manage-user-' + row.user.id
    }, [_c('td', {
      staticClass: "six wide"
    }, [_vm._v("\n                          " + _vm._s(row.user.email) + "\n                          "), (row.user.isOwner) ? _c('span', {
      staticClass: "ui tiny green basic label",
      staticStyle: {
        "margin-left": "0.5em"
      }
    }, [_vm._v("Owner")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.user.firstName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.user.lastName))]), _vm._v(" "), _c('td', {
      staticClass: "five wide"
    }, [(row.emailAddress) ? [_c('div', {
      class: row.emailAddress.emailVerified && row.emailAddress.email === row.emailAddress.originalEmail ? 'ui green basic label' : 'ui red basic label',
      staticStyle: {
        "min-width": "90px",
        "text-align": "center",
        "margin-right": "10px",
        "background-color": "#fff !important"
      }
    }, [_vm._v(_vm._s(row.emailAddress.emailVerified ? 'Verified' : 'Not verified'))]), _vm._v(" "), _c('button', {
      class: !row.emailAddress.emailVerified && !row.emailAddress.isNew && !row.emailAddress.verificationEmailSent && row.emailAddress.email === row.emailAddress.originalEmail ? 'ui tiny icon button' : 'ui tiny icon disabled button',
      attrs: {
        "data-tooltip": "Resend Verification E-Mail",
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.resendVerification(row.emailAddress)
        }
      }
    }, [_c('i', {
      staticClass: "mail icon"
    })])] : _c('span', {
      staticClass: "disabled"
    }, [_vm._v("—")])], 2)])
  }), _vm._v(" "), (!_vm.tenantUsersLoading && _vm.manageUsersTableRows.length === 0) ? _c('tr', [_c('td', {
    staticClass: "disabled",
    staticStyle: {
      "text-align": "center",
      "padding": "1.5em"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("\n                          No users on this account yet. Use Add User to invite teammates.\n                        ")])]) : _vm._e()]], 2)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOwner),
      expression: "isOwner"
    }],
    staticClass: "row marginBotton-1 margin-top-2"
  }, [_vm._m(5)]), _vm._v(" "), (_vm.teamsMessage) ? _c('div', {
    staticClass: "row centered"
  }, [_c('div', {
    staticClass: "ui positive message transition",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n                " + _vm._s(_vm.teamsMessage) + "\n              ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOwner),
      expression: "isOwner"
    }],
    staticClass: "ui column centered grid",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(6)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOwner),
      expression: "isOwner"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "two wide column"
  }), _vm._v(" "), _c('div', {
    staticClass: "four wide column"
  }, [_c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("Storefronts")]), _vm._v(" "), _c('div', {
    ref: "storefrontTeamSelect",
    staticClass: "ui fluid multiple search selection dropdown"
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "selectedTeamStorefronts"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "dropdown icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "default text"
  }, [_vm._v("Select storefronts")]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, _vm._l((_vm.sellers), function(seller) {
    return _c('div', {
      key: 'team-sf-' + (seller.sellerId && seller.sellerId.value != null ? seller.sellerId.value : seller.sellerId),
      staticClass: "item",
      attrs: {
        "data-value": String(seller.sellerId && seller.sellerId.value != null ? seller.sellerId.value : seller.sellerId)
      }
    }, [_vm._v("\n                        " + _vm._s(seller.nickName) + "\n                      ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "eight wide column"
  }, [_c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("Select User")]), _vm._v(" "), [_c('div', {
    ref: "assignedUser",
    staticClass: "ui multiple selection dropdown"
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "selectedAssignedUser"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "dropdown icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "default text"
  }, [_vm._v("Select Users")]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "-1"
    },
    on: {
      "click": _vm.selectAssignedUser
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.tenantUsersForTeamAndAlertsDropdown), function(u) {
    return _c('div', {
      key: 'team-user-' + u.id,
      staticClass: "item",
      attrs: {
        "data-value": u.email
      },
      on: {
        "click": function($event) {
          return _vm.selectAssignedUser({
            email: u.email,
            emailAddressId: u.id
          })
        }
      }
    }, [_vm._v("\n                            " + _vm._s(_vm.formatTenantUserDropdownLabel(u)) + "\n                          ")])
  })], 2)])]], 2)])]), _vm._v(" "), (_vm.isOwner) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "two wide column"
  }), _vm._v(" "), _c('div', {
    staticClass: "twelve wide column"
  }, [_c('table', {
    staticClass: "ui very basic compact table"
  }, _vm._l((_vm.assignedUserList), function(ea, i) {
    return (!ea.isDeleted && !ea.isPrimary) ? _c('tbody', {
      key: ea.emailAddressId
    }, [_c('tr', [_c('td', {
      staticClass: "six wide"
    }, [_vm._v(_vm._s(ea.email))]), _vm._v(" "), _c('td', {
      staticClass: "four wide"
    }, [_vm._v(_vm._s(ea.firstName))]), _vm._v(" "), _c('td', {
      staticClass: "four wide"
    }, [_vm._v(_vm._s(ea.lastName))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "ui tiny icon button",
      attrs: {
        "data-tooltip": "Delete Storefront User"
      },
      on: {
        "click": function($event) {
          return _vm.deleteAssignedUser(ea)
        }
      }
    }, [_c('i', {
      staticClass: "trash alternate outline icon"
    })])])])]) : _vm._e()
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.isOwner) ? _c('div', {
    staticClass: "ui container"
  }, [_c('div', {
    staticClass: "ui clearing"
  }, [_c('button', {
    class: (_vm.isEmptyObject(_vm.assignedUserList) || !_vm.selectedTeamStorefronts.length) ? 'ui right floated primary disabled button' : 'ui right floated primary button',
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveStorefrontTeams.apply(null, arguments)
      }
    }
  }, [_vm._v("Save")])])]) : _vm._e(), _vm._v(" "), (_vm.isOwner) ? _c('div', {
    staticClass: "row margin-top-2",
    staticStyle: {
      "padding-bottom": "0px",
      "margin-bottom": "-5px"
    }
  }, [_vm._m(7)]) : _vm._e(), _vm._v(" "), (_vm.alertMessage) ? _c('div', {
    staticClass: "row centered"
  }, [_c('div', {
    staticClass: "ui positive message transition",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n                    " + _vm._s(_vm.alertMessage) + "\n                  ")])])]) : _vm._e(), _vm._v(" "), (_vm.isOwner) ? _c('div', {
    staticClass: "ui column centered grid",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "column row sub-heading"
  }, [_vm._v("Optimize your teams performance, by customizing indivual user alerts, warnings and product improvements.")])]) : _vm._e(), _vm._v(" "), (_vm.isOwner) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "two wide column"
  }), _vm._v(" "), _c('div', {
    staticClass: "four wide column"
  }, [_c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("Select User")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.alertUser),
      expression: "alertUser"
    }],
    ref: "alertUser",
    staticClass: "ui search selection dropdown",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.alertUser = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.onAlertUserChange]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select user")]), _vm._v(" "), _vm._l((_vm.tenantUsersForTeamAndAlertsDropdown), function(u) {
    return _c('option', {
      key: 'alert-user-' + u.id,
      domProps: {
        "value": u.email
      }
    }, [_vm._v("\n                          " + _vm._s(_vm.formatTenantUserDropdownLabel(u)) + "\n                        ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "four wide column"
  }, [_c('div', {
    staticClass: "ui field"
  }, [(_vm.isOwner && _vm.alertUser) ? _c('button', {
    staticClass: "ui labeled icon button borderButton",
    staticStyle: {
      "margin-top": "25px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.manageAlertSettings = !_vm.manageAlertSettings
      }
    }
  }, [_c('i', {
    staticClass: "sliders horizontal icon"
  }), _vm._v("Customize Alert")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.manageAlertSettings && _vm.alertUser) ? _c('div', {
    staticClass: "ui column centered grid",
    staticStyle: {
      "width": "75%"
    }
  }, [_c('div', {
    staticClass: "ui divider"
  })]) : _vm._e(), _vm._v(" "), (_vm.manageAlertSettings && _vm.alertUser) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "two wide column"
  }), _vm._v(" "), _c('div', {
    staticClass: "twelve wide column"
  }, [_c('table', {
    staticClass: "ui very basic compact table"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "six wide"
  }, [_vm._v("Enable all email alerts")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enableAllAlerts),
      expression: "enableAllAlerts"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.enableAllAlerts) ? _vm._i(_vm.enableAllAlerts, null) > -1 : (_vm.enableAllAlerts)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.enableAllAlerts,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.enableAllAlerts = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.enableAllAlerts = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.enableAllAlerts = $$c
        }
      }, _vm.onEnableAllAlertChange]
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "six wide"
  }, [_vm._v("Disable all email alerts")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.disableAllAlerts),
      expression: "disableAllAlerts"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.disableAllAlerts) ? _vm._i(_vm.disableAllAlerts, null) > -1 : (_vm.disableAllAlerts)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.disableAllAlerts,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.disableAllAlerts = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.disableAllAlerts = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.disableAllAlerts = $$c
        }
      }, _vm.onDisableAllAlertChange]
    }
  })])])])])])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeDown"
    }
  }, _vm._l((_vm.alertUserList), function(ea, i) {
    return (_vm.manageAlertSettings && _vm.alertUser) ? _c('div', {
      staticClass: "ui sixteen wide column"
    }, [_c('div', {
      staticStyle: {
        "padding-top": "10px",
        "padding-left": "40px",
        "padding-right": "20px"
      },
      attrs: {
        "colspan": "4"
      }
    }, [_c('div', {
      staticClass: "ui centered segment"
    }, [_c('table', {
      staticClass: "ui striped very basic table"
    }, [_c('thead', [_c('tr', [_c('th', {
      staticStyle: {
        "color": "purple",
        "padding": "10px"
      }
    }, [_c('small', [_vm._v("A more detailed description of each alert type is available\n                                "), _c('br'), _vm._v(" in the [Issues] section, under the [info] tab of each box.\n                              ")])]), _vm._v(" "), _c('th', {
      staticStyle: {
        "color": "red"
      },
      attrs: {
        "width": "80px"
      }
    }, [_c('i', {
      staticClass: "warning circle icon"
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "text-decoration": "underline",
        "text-decoration-style": "dotted"
      },
      attrs: {
        "data-inverted": "",
        "data-tooltip": "Alert: An issue that needs your attention.",
        "data-position": "top right"
      }
    }, [_vm._v("\n                                Alert\n                              ")])]), _vm._v(" "), _c('th', {
      staticStyle: {
        "color": "orange"
      },
      attrs: {
        "width": "80px"
      }
    }, [_c('span', {
      staticStyle: {
        "text-decoration": "underline",
        "text-decoration-style": "dotted"
      },
      attrs: {
        "data-inverted": "",
        "data-tooltip": "Warning: A lesser important issue.",
        "data-position": "top right"
      }
    }, [_vm._v("\n                                Warning\n                              ")])]), _vm._v(" "), _c('th', {
      staticStyle: {
        "color": "green"
      },
      attrs: {
        "width": "85px"
      }
    }, [_c('i', {
      staticClass: "checkmark circle icon"
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "text-decoration": "underline",
        "text-decoration-style": "dotted"
      },
      attrs: {
        "data-inverted": "",
        "data-tooltip": "Improvement: A positive change.",
        "data-position": "top right"
      }
    }, [_vm._v("\n                                Imprv.\n                              ")])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.watchDogTypes), function(wdt) {
      return _c('tr', {
        key: wdt,
        class: {
          'greyed-out': _vm.isSuppressed(wdt)
        }
      }, [_c('td', {
        staticStyle: {
          "padding-left": "10px"
        }
      }, [_vm._v("\n                              Subscribe to \"" + _vm._s(_vm.watchDogTypesToDisplayName[wdt]) + "\" Emails\n                            ")]), _vm._v(" "), _c('td', {
        staticClass: "center aligned"
      }, [(ea.alertsSettings && ea.alertsSettings[wdt]) ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ea.alertsSettings[wdt]['RED']),
          expression: "ea.alertsSettings[wdt]['RED']"
        }],
        attrs: {
          "type": "checkbox",
          "data-lpignore": "true",
          "disabled": _vm.isSuppressed(wdt)
        },
        domProps: {
          "checked": Array.isArray(ea.alertsSettings[wdt]['RED']) ? _vm._i(ea.alertsSettings[wdt]['RED'], null) > -1 : (ea.alertsSettings[wdt]['RED'])
        },
        on: {
          "change": function($event) {
            var $$a = ea.alertsSettings[wdt]['RED'],
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(ea.alertsSettings[wdt], 'RED', $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(ea.alertsSettings[wdt], 'RED', $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(ea.alertsSettings[wdt], 'RED', $$c)
            }
          }
        }
      }) : _vm._e()]), _vm._v(" "), _c('td', {
        staticClass: "center aligned"
      }, [(ea.alertsSettings && ea.alertsSettings[wdt]) ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ea.alertsSettings[wdt]['AMBER']),
          expression: "ea.alertsSettings[wdt]['AMBER']"
        }],
        attrs: {
          "type": "checkbox",
          "data-lpignore": "true",
          "disabled": _vm.isSuppressed(wdt)
        },
        domProps: {
          "checked": Array.isArray(ea.alertsSettings[wdt]['AMBER']) ? _vm._i(ea.alertsSettings[wdt]['AMBER'], null) > -1 : (ea.alertsSettings[wdt]['AMBER'])
        },
        on: {
          "change": function($event) {
            var $$a = ea.alertsSettings[wdt]['AMBER'],
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(ea.alertsSettings[wdt], 'AMBER', $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(ea.alertsSettings[wdt], 'AMBER', $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(ea.alertsSettings[wdt], 'AMBER', $$c)
            }
          }
        }
      }) : _vm._e()]), _vm._v(" "), _c('td', {
        staticClass: "center aligned"
      }, [(ea.alertsSettings && ea.alertsSettings[wdt]) ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ea.alertsSettings[wdt]['GREEN']),
          expression: "ea.alertsSettings[wdt]['GREEN']"
        }],
        attrs: {
          "type": "checkbox",
          "data-lpignore": "true",
          "disabled": _vm.isSuppressed(wdt)
        },
        domProps: {
          "checked": Array.isArray(ea.alertsSettings[wdt]['GREEN']) ? _vm._i(ea.alertsSettings[wdt]['GREEN'], null) > -1 : (ea.alertsSettings[wdt]['GREEN'])
        },
        on: {
          "change": function($event) {
            var $$a = ea.alertsSettings[wdt]['GREEN'],
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(ea.alertsSettings[wdt], 'GREEN', $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(ea.alertsSettings[wdt], 'GREEN', $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(ea.alertsSettings[wdt], 'GREEN', $$c)
            }
          }
        }
      }) : _vm._e()])])
    }), 0)]), _vm._v(" "), _c('table', {
      staticClass: "ui striped very basic table"
    }, [_c('thead', [_c('th'), _vm._v(" "), _c('th', {
      attrs: {
        "width": "160px"
      }
    }, [_vm._v("Team Setting Defaults")]), _vm._v(" "), _c('th', {
      attrs: {
        "width": "80px"
      }
    }, [_vm._v(" ")])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
      staticStyle: {
        "padding-left": "10px"
      }
    }, [_vm._v("Subscribe to Daily Digest Email")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding-left": "35px"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (ea.subscribedToDailyDigestEmail),
        expression: "ea.subscribedToDailyDigestEmail"
      }],
      attrs: {
        "type": "checkbox",
        "data-lpignore": "true"
      },
      domProps: {
        "checked": Array.isArray(ea.subscribedToDailyDigestEmail) ? _vm._i(ea.subscribedToDailyDigestEmail, null) > -1 : (ea.subscribedToDailyDigestEmail)
      },
      on: {
        "change": function($event) {
          var $$a = ea.subscribedToDailyDigestEmail,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(ea, "subscribedToDailyDigestEmail", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(ea, "subscribedToDailyDigestEmail", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(ea, "subscribedToDailyDigestEmail", $$c)
          }
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "padding-left": "10px"
      }
    }, [_vm._v("Subscribe to SentryKit Product Updates")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding-left": "35px"
      }
    }, [_c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (ea.subscribedToNewsletter),
        expression: "ea.subscribedToNewsletter"
      }],
      attrs: {
        "type": "checkbox",
        "data-lpignore": "true"
      },
      domProps: {
        "checked": Array.isArray(ea.subscribedToNewsletter) ? _vm._i(ea.subscribedToNewsletter, null) > -1 : (ea.subscribedToNewsletter)
      },
      on: {
        "change": function($event) {
          var $$a = ea.subscribedToNewsletter,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(ea, "subscribedToNewsletter", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(ea, "subscribedToNewsletter", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(ea, "subscribedToNewsletter", $$c)
          }
        }
      }
    })])])])])]), _vm._v(" "), _c('daily-digest-timing', {
      attrs: {
        "emailAddress": ea
      },
      on: {
        "digestTimingUpdated": ea.updateDigestTiming
      }
    }), _vm._v(" "), (_vm.emailDirty) ? _c('h4', {
      staticClass: "changed-color"
    }, [_vm._v("* The settings have changed, click Save on the bottom of the screen.")]) : _vm._e()], 1)])]) : _vm._e()
  }), 0), _vm._v(" "), (_vm.isOwner) ? _c('div', {
    staticClass: "ui container"
  }, [_c('div', {
    staticClass: "ui clearing"
  }, [_c('button', {
    class: _vm.emailDirty ? 'ui right floated primary button' : 'ui right floated primary disabled button',
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save('alerts')
      }
    }
  }, [_vm._v("Save")])])]) : _vm._e(), _vm._v(" "), _vm._m(8), _vm._v(" "), (_vm.isOwner) ? _c('div', {
    staticClass: "ui column centered grid",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "column row sub-heading"
  }, [_vm._v("Set up team notification channels, like Slack or Teams, for group alerts.")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "two wide column"
  }, [_c('h4', {
    class: _vm.emailDirty ? 'changed-color' : '',
    staticStyle: {
      "padding-top": "30px"
    }
  }, [_vm._v("Email Alerts")])]), _vm._v(" "), _c('div', {
    staticClass: "fourteen wide column"
  }, [_c('table', {
    staticClass: "ui very basic table emailSettingsTable"
  }, _vm._l((_vm.emailAddresses), function(ea, i) {
    return (!ea.isDeleted && (!ea.isUser || ea.isPrimary) && (_vm.isOwner || ea.isPrimary)) ? _c('tbody', {
      key: ea.emailAddressId
    }, [_c('tr', [(!ea.isNew && !ea.isPrimary) ? _c('td', {
      staticClass: "seven wide"
    }, [_vm._v(_vm._s(ea.email))]) : _c('td', {
      staticClass: "seven wide"
    }, [_c('div', {
      class: ea.emailValid ? 'field' : 'error field'
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (ea.email),
        expression: "ea.email"
      }],
      staticClass: "ui input focus",
      attrs: {
        "name": "emailaddrs",
        "data-lpignore": "true",
        "required": "required",
        "maxlength": "100"
      },
      domProps: {
        "value": (ea.email)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(ea, "email", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('td', {
      staticClass: "five wide"
    }, [_c('div', {
      class: ea.emailVerified && ea.email === ea.originalEmail ? 'ui green basic label' : 'ui red basic label',
      staticStyle: {
        "min-width": "90px",
        "text-align": "center",
        "margin-right": "10px",
        "background-color": "#fff !important"
      }
    }, [_vm._v(_vm._s(ea.emailVerified ? 'Verified' : 'Not verified'))]), _vm._v(" "), _c('button', {
      class: !ea.emailVerified && !ea.isNew && !ea.verificationEmailSent && ea.email === ea.originalEmail ? 'ui tiny icon button' : 'ui tiny icon disabled button',
      attrs: {
        "data-tooltip": "Resend Verification E-Mail",
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.resendVerification(ea)
        }
      }
    }, [_c('i', {
      staticClass: "mail icon"
    })])]), _vm._v(" "), _c('td', {
      staticClass: "five wide"
    }, [(i == 0) ? _c('div', {
      class: {
        'alertSettingsAni': _vm.alertSettingsAni
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "ui labeled tiny icon button borderButton",
      on: {
        "click": function($event) {
          ea.manageSubscriptionSettings = !ea.manageSubscriptionSettings
        }
      }
    }, [_c('i', {
      staticClass: "sliders horizontal icon"
    }), _vm._v("Manage Alerts\n                        ")])]), _vm._v(" "), (ea.isUser && !ea.isPrimary && _vm.isOwner) ? _c('td', {
      staticClass: "five wide"
    }, [_c('div', {
      staticClass: "ui labeled tiny orange icon button",
      on: {
        "click": function($event) {
          ea.manageSellerPermissions = !ea.manageSellerPermissions
        }
      }
    }, [_c('i', {
      staticClass: "cogs horizontal icon"
    }), _vm._v("Manage Permissions\n                        ")])]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "one wide"
    }, [(ea.isPrimary) ? _c('i', [_vm._v("Account Login Address")]) : _c('div', {
      staticClass: "ui tiny icon button",
      on: {
        "click": function($event) {
          return _vm.deleteEmailAddress(i)
        }
      }
    }, [_c('i', {
      staticClass: "trash alternate outline icon"
    })])])]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "fadeDown"
      }
    }, [(ea.convertIntoUser) ? _c('tr', {
      staticStyle: {
        "max-width": "500px"
      }
    }, [_c('td', {
      attrs: {
        "colspan": "4"
      }
    }, [_c('div', {
      staticClass: "ui segment"
    }, [_c('form', {
      staticClass: "ui form",
      attrs: {
        "action": "javascript:void(0)"
      }
    }, [_c('div', {
      staticClass: "field"
    }, [_c('label', [_vm._v("Name *")]), _vm._v(" "), _c('div', {
      staticClass: "two fields"
    }, [_c('div', {
      staticClass: "field focus"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.user.firstName),
        expression: "user.firstName"
      }],
      attrs: {
        "type": "text",
        "name": "firstName",
        "placeholder": _vm.$t('First Name'),
        "required": "true",
        "autofocus": "true"
      },
      domProps: {
        "value": (_vm.user.firstName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.user, "firstName", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.user.lastName),
        expression: "user.lastName"
      }],
      attrs: {
        "type": "text",
        "name": "lastName",
        "placeholder": _vm.$t('Last Name'),
        "required": "true",
        "autofocus": "true"
      },
      domProps: {
        "value": (_vm.user.lastName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.user, "lastName", $event.target.value)
        }
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "field"
    }, [_c('label', [_vm._v(_vm._s(_vm._f("translate")('Email *')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.user.email),
        expression: "user.email"
      }],
      attrs: {
        "id": "email",
        "type": "email",
        "name": "email",
        "placeholder": _vm.$t('Email'),
        "readonly": "true"
      },
      domProps: {
        "value": (_vm.user.email)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.user, "email", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "ui tiny blue icon button",
      on: {
        "click": function($event) {
          return _vm.convertIntoUser(i)
        }
      }
    }, [_vm._v("\n                              convert\n                            ")])])])])]) : _vm._e()]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "fadeDown"
      }
    }, [(ea.manageSubscriptionSettings) ? _c('tr', [_c('td', {
      staticStyle: {
        "padding-top": "10px",
        "padding-left": "40px",
        "padding-right": "20px"
      },
      attrs: {
        "colspan": "4"
      }
    }, [_c('div', {
      staticClass: "ui segment"
    }, [_c('table', {
      staticClass: "ui striped very basic table"
    }, [_c('thead', [_c('tr', [_c('th', {
      staticStyle: {
        "color": "purple",
        "padding": "10px"
      }
    }, [_c('small', [_vm._v("A more detailed description of each alert type is available\n                                    "), _c('br'), _vm._v(" in the [Issues] section, under the [info] tab of each box.\n                                  ")])]), _vm._v(" "), _c('th', {
      staticStyle: {
        "color": "red"
      },
      attrs: {
        "width": "80px"
      }
    }, [_c('i', {
      staticClass: "warning circle icon"
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "text-decoration": "underline",
        "text-decoration-style": "dotted"
      },
      attrs: {
        "data-inverted": "",
        "data-tooltip": "Alert: An issue that needs your attention.",
        "data-position": "top right"
      }
    }, [_vm._v("\n                                    Alert\n                                  ")])]), _vm._v(" "), _c('th', {
      staticStyle: {
        "color": "orange"
      },
      attrs: {
        "width": "80px"
      }
    }, [_c('span', {
      staticStyle: {
        "text-decoration": "underline",
        "text-decoration-style": "dotted"
      },
      attrs: {
        "data-inverted": "",
        "data-tooltip": "Warning: A lesser important issue.",
        "data-position": "top right"
      }
    }, [_vm._v("\n                                    Warning\n                                  ")])]), _vm._v(" "), _c('th', {
      staticStyle: {
        "color": "green"
      },
      attrs: {
        "width": "85px"
      }
    }, [_c('i', {
      staticClass: "checkmark circle icon"
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "text-decoration": "underline",
        "text-decoration-style": "dotted"
      },
      attrs: {
        "data-inverted": "",
        "data-tooltip": "Improvement: A positive change.",
        "data-position": "top right"
      }
    }, [_vm._v("\n                                    Imprv.\n                                  ")])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.watchDogTypes), function(wdt) {
      return _c('tr', {
        key: wdt,
        class: {
          'greyed-out': _vm.isSuppressed(wdt)
        }
      }, [_c('td', {
        staticStyle: {
          "padding-left": "10px"
        }
      }, [_vm._v("\n                                  Subscribe to \"" + _vm._s(_vm.watchDogTypesToDisplayName[wdt]) + "\" Emails\n                                ")]), _vm._v(" "), _c('td', {
        staticClass: "center aligned"
      }, [(ea.alertsSettings && ea.alertsSettings[wdt]) ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ea.alertsSettings[wdt]['RED']),
          expression: "ea.alertsSettings[wdt]['RED']"
        }],
        attrs: {
          "type": "checkbox",
          "data-lpignore": "true",
          "disabled": _vm.isSuppressed(wdt)
        },
        domProps: {
          "checked": Array.isArray(ea.alertsSettings[wdt]['RED']) ? _vm._i(ea.alertsSettings[wdt]['RED'], null) > -1 : (ea.alertsSettings[wdt]['RED'])
        },
        on: {
          "change": function($event) {
            var $$a = ea.alertsSettings[wdt]['RED'],
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(ea.alertsSettings[wdt], 'RED', $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(ea.alertsSettings[wdt], 'RED', $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(ea.alertsSettings[wdt], 'RED', $$c)
            }
          }
        }
      }) : _vm._e()]), _vm._v(" "), _c('td', {
        staticClass: "center aligned"
      }, [(ea.alertsSettings && ea.alertsSettings[wdt]) ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ea.alertsSettings[wdt]['AMBER']),
          expression: "ea.alertsSettings[wdt]['AMBER']"
        }],
        attrs: {
          "type": "checkbox",
          "data-lpignore": "true",
          "disabled": _vm.isSuppressed(wdt)
        },
        domProps: {
          "checked": Array.isArray(ea.alertsSettings[wdt]['AMBER']) ? _vm._i(ea.alertsSettings[wdt]['AMBER'], null) > -1 : (ea.alertsSettings[wdt]['AMBER'])
        },
        on: {
          "change": function($event) {
            var $$a = ea.alertsSettings[wdt]['AMBER'],
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(ea.alertsSettings[wdt], 'AMBER', $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(ea.alertsSettings[wdt], 'AMBER', $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(ea.alertsSettings[wdt], 'AMBER', $$c)
            }
          }
        }
      }) : _vm._e()]), _vm._v(" "), _c('td', {
        staticClass: "center aligned"
      }, [(ea.alertsSettings && ea.alertsSettings[wdt]) ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (ea.alertsSettings[wdt]['GREEN']),
          expression: "ea.alertsSettings[wdt]['GREEN']"
        }],
        attrs: {
          "type": "checkbox",
          "data-lpignore": "true",
          "disabled": _vm.isSuppressed(wdt)
        },
        domProps: {
          "checked": Array.isArray(ea.alertsSettings[wdt]['GREEN']) ? _vm._i(ea.alertsSettings[wdt]['GREEN'], null) > -1 : (ea.alertsSettings[wdt]['GREEN'])
        },
        on: {
          "change": function($event) {
            var $$a = ea.alertsSettings[wdt]['GREEN'],
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(ea.alertsSettings[wdt], 'GREEN', $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(ea.alertsSettings[wdt], 'GREEN', $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(ea.alertsSettings[wdt], 'GREEN', $$c)
            }
          }
        }
      }) : _vm._e()])])
    }), 0)]), _vm._v(" "), (!_vm.isEmptyObject(_vm.filteredSellers)) ? _c('div', {
      staticClass: "twelve wide column"
    }, [_c('h3', [_vm._v("\n                              Seller accounts subscribed\n                            ")]), _vm._v(" "), _c('table', {
      staticClass: "ui very basic compact table"
    }, [_c('thead', [_c('tr', [_c('th', {
      staticClass: "three wide"
    }, [_vm._v("Seller ID")]), _vm._v(" "), _c('th', {
      staticClass: "one wide"
    }, [_vm._v("Region")]), _vm._v(" "), _c('th', {
      staticClass: "four wide"
    }, [_vm._v("Account nick name")]), _vm._v(" "), _c('th', {
      staticClass: "four wide"
    }, [_vm._v("Subscribed")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredSellers), function(seller) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(seller.sellerKey.value))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(seller.region))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(seller.nickName))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "padding-left": "35px"
        }
      }, [_c('input', {
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": ea.unsubscribedSellerAccounts.indexOf(seller.sellerId.value) === -1
        },
        on: {
          "click": function($event) {
            return _vm.checkSubscribe(seller.sellerId.value, i)
          }
        }
      })])])
    }), 0)])]) : _vm._e(), _vm._v(" "), _c('table', {
      staticClass: "ui striped very basic table"
    }, [_c('thead', [_c('th'), _vm._v(" "), _c('th', {
      attrs: {
        "width": "160px"
      }
    }, [_vm._v("Daily Digest")]), _vm._v(" "), _c('th', {
      attrs: {
        "width": "80px"
      }
    }, [_vm._v(" ")])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
      staticStyle: {
        "padding-left": "10px"
      }
    }, [_vm._v("Subscribe to Daily Digest Email")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding-left": "35px"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (ea.subscribedToDailyDigestEmail),
        expression: "ea.subscribedToDailyDigestEmail"
      }],
      attrs: {
        "type": "checkbox",
        "data-lpignore": "true"
      },
      domProps: {
        "checked": Array.isArray(ea.subscribedToDailyDigestEmail) ? _vm._i(ea.subscribedToDailyDigestEmail, null) > -1 : (ea.subscribedToDailyDigestEmail)
      },
      on: {
        "change": function($event) {
          var $$a = ea.subscribedToDailyDigestEmail,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(ea, "subscribedToDailyDigestEmail", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(ea, "subscribedToDailyDigestEmail", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(ea, "subscribedToDailyDigestEmail", $$c)
          }
        }
      }
    })])])])]), _vm._v(" "), _c('table', {
      staticClass: "ui striped very basic table"
    }, [_c('thead', [_c('th'), _vm._v(" "), _c('th', {
      attrs: {
        "width": "240px"
      }
    }, [_vm._v("Product Updates")])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
      staticStyle: {
        "padding-left": "10px"
      }
    }, [_vm._v("Subscribe to Product Updates")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding-left": "35px"
      }
    }, [(!ea.isPrimary) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (ea.subscribedToNewsletter),
        expression: "ea.subscribedToNewsletter"
      }],
      attrs: {
        "type": "checkbox",
        "data-lpignore": "true"
      },
      domProps: {
        "checked": Array.isArray(ea.subscribedToNewsletter) ? _vm._i(ea.subscribedToNewsletter, null) > -1 : (ea.subscribedToNewsletter)
      },
      on: {
        "change": function($event) {
          var $$a = ea.subscribedToNewsletter,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(ea, "subscribedToNewsletter", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(ea, "subscribedToNewsletter", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(ea, "subscribedToNewsletter", $$c)
          }
        }
      }
    })]) : _c('span', [_c('input', {
      staticStyle: {
        "margin-top": "3px"
      },
      attrs: {
        "type": "checkbox",
        "checked": "checked",
        "disabled": "disabled"
      }
    }), _vm._v(" "), _c('span', {
      attrs: {
        "data-tooltip": "For the Primary Email address Product Update messages are always on."
      }
    }, [_c('i', {
      staticClass: "ui question circle icon"
    })])])])])])]), _vm._v(" "), _c('daily-digest-timing', {
      attrs: {
        "emailAddress": ea
      },
      on: {
        "digestTimingUpdated": ea.updateDigestTiming
      }
    }), _vm._v(" "), (_vm.emailDirty) ? _c('h4', {
      staticClass: "changed-color"
    }, [_vm._v("* The settings have changed, click Save on the bottom of the screen.")]) : _vm._e()], 1)])]) : _vm._e()]), _vm._v(" "), _c('transition', [(ea.manageSellerPermissions) ? _c('tr', [_c('td', {
      staticStyle: {
        "padding-top": "10px",
        "padding-left": "40px",
        "padding-right": "20px"
      },
      attrs: {
        "colspan": "4"
      }
    }, [_c('div', {
      staticClass: "ui segment"
    }, [(!_vm.isEmptyObject(_vm.sellers)) ? _c('div', {
      staticClass: "twelve wide column"
    }, [_c('h3', [_vm._v("\n                                Seller accounts Permission\n                              ")]), _vm._v(" "), _c('table', {
      staticClass: "ui very basic compact table"
    }, [_c('thead', [_c('tr', [_c('th', {
      staticClass: "three wide"
    }, [_vm._v("Seller ID")]), _vm._v(" "), _c('th', {
      staticClass: "one wide"
    }, [_vm._v("Region")]), _vm._v(" "), _c('th', {
      staticClass: "four wide"
    }, [_vm._v("Account nick name")]), _vm._v(" "), _c('th', {
      staticClass: "four wide"
    }, [_vm._v("Access")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.sellers), function(seller) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(seller.sellerKey.value))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(seller.region))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(seller.nickName))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "padding-left": "35px"
        }
      }, [_c('input', {
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": ea.allowedSellerAccounts.indexOf(seller.sellerId.value) !== -1
        },
        on: {
          "click": function($event) {
            return _vm.checkSellerAccountsAccess(seller.sellerId.value, i)
          }
        }
      })])])
    }), 0)]), _vm._v(" "), (_vm.emailDirty) ? _c('h4', {
      staticClass: "changed-color"
    }, [_vm._v("* The settings have changed, click Save on the bottom of the screen.")]) : _vm._e()]) : _vm._e()])])]) : _vm._e()])], 1) : _vm._e()
  }), 0), _vm._v(" "), (_vm.isOwner) ? _c('button', {
    class: _vm.addEmailAddressInProgress ? 'ui loading button' : 'ui  labeled icon button borderButton',
    staticStyle: {
      "margin-top": "-10px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addEmailAddress()
      }
    }
  }, [_c('i', {
    staticClass: "add circle icon"
  }), _vm._v("Add New Email Channel")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ui basic segment"
  })])]), _vm._v(" "), _vm._m(9), _vm._v(" "), (_vm.isOwner) ? _c('div', {
    staticClass: "ui column centered grid",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(10)]) : _vm._e(), _vm._v(" "), (_vm.isOwner) ? _c('hr', {
    staticClass: "marginBotton-2",
    staticStyle: {
      "width": "40%"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isOwner) ? _c('div', {
    staticClass: "ui column centered grid",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('h3', [_vm._v("Connect third-party apps")])]) : _vm._e(), _vm._v(" "), (_vm.isOwner) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "sixteen wide column"
  }, [_c('div', {
    staticClass: "ui placeholder segment"
  }, [_c('div', {
    staticClass: "ui two column very relaxed stackable grid"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "ui striped very basic table"
  }, [_c('tbody', [_c('tr', [_vm._m(11), _vm._v(" "), _c('td', [_c('a', {
    class: _vm.zapierAuth && _vm.zapierAuth.length > 0 ? 'ui labeled icon button borderButton' : 'ui labeled icon button',
    attrs: {
      "target": "_blank",
      "href": "https://zapier.com/engine/auth/start/App240321CLIAPI@1.0.0/?_zapier_account_id=4400475"
    }
  }, [_c('i', {
    staticClass: "plug icon"
  }), _vm._v("\n                              Connect Zapier")])])])])]), _vm._v(" "), (_vm.zapierList.length > 0) ? _c('div', {
    staticClass: "six wide column"
  }, [_c('span', [_vm._v("Check out all the ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://docs.google.com/document/d/15O8b4mBsAb7ccIrL05jcxJCuo9_kDemcXkgjwMy_VA4/edit?usp=sharing",
      "target": "_blank"
    }
  }, [_vm._v("triggers")]), _vm._v(" you can use in your SentryKit Zaps.\n                        ")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.hasZapier) ? _c('table', {
    staticClass: "ui striped very basic table",
    staticStyle: {
      "margin-top": "1rem"
    }
  }, [_c('tbody', _vm._l((_vm.zapierList), function(z) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "100px"
      }
    }, [_vm._v("Added at " + _vm._s(new Date(z.timestamp).toLocaleDateString()))]), _vm._v(" "), _c('td', [_c('div', {
      class: _vm.a.clicked ? 'ui primary button' : 'ui button',
      on: {
        "click": function($event) {
          return _vm.deleteAuthorization(z)
        }
      }
    }, [_vm._v(_vm._s(z.clicked ? 'Confirm revoking authorization' : 'Revoke authorization'))])])])
  }), 0)]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [(_vm.gsheetsConnection.enabled && _vm.isOwner) ? _c('div', [(_vm.gsheetsConnection.email) ? _c('div', {
    staticClass: "five wide column"
  }, [_vm._m(12)]) : _vm._e(), _vm._v(" "), (_vm.gsheetsConnection.email) ? _c('div', {
    staticClass: "six wide column"
  }, [(_vm.gsheetsConnection.spreadsheetId) ? _c('span', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.googleSheetsUrl()
      }
    }
  }, [_vm._v("Open SentryKit Spreadsheet")])]) : _vm._e(), _c('br'), _vm._v("\n                        (" + _vm._s(_vm.gsheetsConnection.email == 'pending' ? 'pending' : 'Connected as ' + _vm.gsheetsConnection.email) + ")\n                        "), (_vm.gsheetsConnection.connectionError) ? _c('div', {
    staticClass: "ui yellow message"
  }, [_c('i', {
    staticClass: "icon exclamation triangle"
  }), _vm._v("\n                          WARNING: SentryKit "), _c('b', [_vm._v("cannot access")]), _vm._v(" your spreadsheet\n                          "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "top": ".3em",
      "right": ".4em"
    },
    attrs: {
      "data-tooltip": "Click here for more info"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.gsheetsArticleLink,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fitted small circular question inverted icon link"
  })])])]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "ui striped very basic table"
  }, [_c('tbody', _vm._l((_vm.googleSheetsList), function(g) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "140px"
      }
    }, [_vm._v("Added at " + _vm._s(new Date(g.timestamp).toLocaleDateString()))]), _vm._v(" "), _c('td', [_c('div', {
      class: g.clicked ? 'ui primary button' : 'ui button',
      on: {
        "click": function($event) {
          return _vm.deleteAuthorization(g)
        }
      }
    }, [_vm._v(_vm._s(g.clicked ? 'Confirm revoking authorization' : 'Revoke authorization'))])])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (!_vm.gsheetsConnection.email) ? _c('div', {
    staticClass: "five wide column"
  }, [_c('table', {
    staticClass: "ui striped very basic table"
  }, [_c('tbody', [_c('tr', [_vm._m(13), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "2rem"
    }
  }, [_c('a', {
    staticClass: "ui labeled icon button",
    on: {
      "click": function($event) {
        return _vm.googleSheetsAuthorizationUrl()
      }
    }
  }, [_c('i', {
    staticClass: "google icon"
  }), _vm._v("\n                            Connect Google Sheets")])])])])])]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "ui vertical divider"
  }, [_vm._v("\n                    |\n                  ")])])])]) : _vm._e(), _vm._v(" "), (_vm.isOwner) ? _c('hr', {
    staticClass: "marginBotton-2",
    staticStyle: {
      "width": "40%"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isOwner) ? _c('div', {
    staticClass: "ui column centered grid",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('h3', [_vm._v("Account-level email alert preferences")]), _vm._v("\n              Account-level settings will affect all users in all storefronts\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "two wide column"
  }, [_c('h4', {
    class: _vm.instantAlertDirty ? 'changed-color' : ''
  }, [_vm._v("Alert Email Preferences")])]), _vm._v(" "), _c('div', {
    staticClass: "fourteen wide column",
    staticStyle: {
      "margin-bottom": "-10px"
    }
  }, [_c('div', {
    staticClass: "inline fields"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui radio checkbox labelCursorFix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.instantAlert),
      expression: "instantAlert"
    }],
    attrs: {
      "type": "radio",
      "name": "instantAlert",
      "id": "radioInstantAlert01"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.instantAlert, true)
    },
    on: {
      "change": function($event) {
        _vm.instantAlert = true
      }
    }
  }), _vm._v(" "), _vm._m(14)])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui radio checkbox labelCursorFix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.instantAlert),
      expression: "instantAlert"
    }],
    attrs: {
      "type": "radio",
      "name": "instantAlert",
      "id": "radioInstantAlert02"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.instantAlert, false)
    },
    on: {
      "change": function($event) {
        _vm.instantAlert = false
      }
    }
  }), _vm._v(" "), _vm._m(15)])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeLeft",
      "mode": "out-in"
    }
  }, [(_vm.instantAlert === true) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "two wide column"
  }, [_c('h4', {
    class: _vm.alertSubjectDirty ? 'changed-color' : ''
  }, [_c('br'), _vm._v("Alert Email Subject")])]), _vm._v(" "), _c('div', {
    staticClass: "fourteen wide column"
  }, [_c('div', {
    staticClass: "grouped fields"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui radio checkbox labelCursorFix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.alertSubject),
      expression: "alertSubject"
    }],
    attrs: {
      "type": "radio",
      "value": "SIMPLE",
      "id": "radioAlertSubject01"
    },
    domProps: {
      "checked": _vm._q(_vm.alertSubject, "SIMPLE")
    },
    on: {
      "change": function($event) {
        _vm.alertSubject = "SIMPLE"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radioAlertSubject01"
    }
  }, [_vm._v("\n                        Simple Subject Line - "), _c('i', [_vm._v("e.g. New SentryKit Notification (Mon, Jul 31, 2017)")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Great for simplicity: Gmail can group these messages by calendar day")])])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui radio checkbox labelCursorFix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.alertSubject),
      expression: "alertSubject"
    }],
    attrs: {
      "type": "radio",
      "value": "DETAILED",
      "id": "radioAlertSubject02"
    },
    domProps: {
      "checked": _vm._q(_vm.alertSubject, "DETAILED")
    },
    on: {
      "change": function($event) {
        _vm.alertSubject = "DETAILED"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radioAlertSubject02"
    }
  }, [_vm._v("\n                        Detailed Subject Line - "), _c('i', [_vm._v("e.g. [alert] Buy-box lost - ProductName [ASIN] (Mon, Jul 31, 2017, 10:25 GMT+02:00)")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Great for creating custom email filters for specific products or issue types")])])])])])])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeLeft",
      "mode": "out-in"
    }
  }, [(_vm.instantAlert === false) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "two wide column"
  }, [_c('h4', {
    class: _vm.batchingIntervalHoursDirty ? 'changed-color' : ''
  }, [_vm._v("Batching Interval")])]), _vm._v(" "), _c('div', {
    staticClass: "fourteen wide column"
  }, [_c('div', {
    staticClass: "inline fields"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui right labeled input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.batchingIntervalHours),
      expression: "batchingIntervalHours",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number",
      "placeholder": "Batching Interval",
      "min": "1",
      "max": "24"
    },
    domProps: {
      "value": (_vm.batchingIntervalHours)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.batchingIntervalHours = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui basic label"
  }, [_vm._v("hours")])])])])])]) : _vm._e()]), _vm._v(" "), _c('hr', {
    staticClass: "marginBotton-2",
    staticStyle: {
      "width": "40%"
    }
  }), _vm._v(" "), (_vm.isOwner) ? _c('div', {
    staticClass: "ui column centered grid",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('h3', [_vm._v("Account Management")]), _vm._v("\n              Change account owner settings, download invoices and update passwords\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "fourteen wide column"
  }, [_c('button', {
    staticClass: "ui labeled icon button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.changePasswordModal.show()
      }
    }
  }, [_c('i', {
    staticClass: "edit icon"
  }), _vm._v("Change password")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "two wide middle aligned column"
  }, [_c('h4', {
    class: _vm.nameDirty ? 'changed-color' : ''
  }, [_vm._v("Account Owner")])]), _vm._v(" "), _c('div', {
    staticClass: "seven wide column"
  }, [_c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("First Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstName),
      expression: "firstName"
    }],
    staticClass: "ui input",
    attrs: {
      "name": "firstName",
      "data-lpignore": "true",
      "required": "true",
      "maxlength": "200"
    },
    domProps: {
      "value": (_vm.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "seven wide column"
  }, [_c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("Last Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastName),
      expression: "lastName"
    }],
    staticClass: "ui input",
    attrs: {
      "name": "lastName",
      "data-lpignore": "true",
      "required": "true",
      "maxlength": "200"
    },
    domProps: {
      "value": (_vm.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastName = $event.target.value
      }
    }
  })])])]), _vm._v(" "), (_vm.$root.paymentStatus !== 0) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOwner),
      expression: "isOwner"
    }],
    staticClass: "row"
  }, [_vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "fourteen wide column"
  }, [_c('p', {
    staticStyle: {
      "white-space": "pre-wrap"
    }
  }, [_vm._v(_vm._s(_vm.paymentStatusMessage))]), _vm._v(" "), _c('div', {
    class: 'ui labeled icon button',
    attrs: {
      "id": "paymentMethods"
    }
  }, [_c('i', {
    staticClass: "credit card alternative icon"
  }), _vm._v(_vm._s(_vm.hasPaymentDetails ? 'Change' : 'Add') + " payment method\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "ui fluid popup"
  }, [_c('div', {
    staticClass: "ui two column center aligned very relaxed grid"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h4', {
    staticClass: "ui header"
  }, [_vm._v("Card")]), _vm._v(" "), _c('button', {
    staticClass: "ui labeled icon button",
    class: {
      loading: _vm.stripeButtonClicked || _vm.updatePaymentInProgress,
      disabled: _vm.updatePaymentInProgress
    },
    staticStyle: {
      "margin": "0.5em 0 1.7em"
    },
    attrs: {
      "id": "stripeButton",
      "type": "button"
    },
    on: {
      "click": _vm.openStripeWidget
    }
  }, [_c('i', {
    staticClass: "credit card alternative icon"
  }), _vm._v(_vm._s(_vm.hasPaymentDetails ? 'Change' : 'Set') + "\n                      ")]), _vm._v(" "), _c('div', {
    staticClass: "ui top right attached teal label"
  }, [_vm._v("Recommended")]), _vm._v(" "), (_vm.paymentMethod && _vm.paymentMethod.method === 'card') ? _c('div', {
    staticClass: "ui bottom attached small blue label"
  }, [_vm._v("\n                        Selected\n                      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h4', {
    staticClass: "ui header"
  }, [_vm._v("ACH transfer")]), _vm._v(" "), _c('div', {
    staticClass: "ui labeled icon button",
    class: {
      loading: _vm.updatePaymentInProgress,
      disabled: _vm.updatePaymentInProgress || _vm.paymentMethod && _vm.paymentMethod.method === 'ach'
    },
    staticStyle: {
      "margin": "0.5em 0 1.7em"
    },
    on: {
      "click": _vm.createAchSource
    }
  }, [_c('i', {
    staticClass: "university icon"
  }), _vm._v("Set\n                      ")]), _vm._v(" "), _c('div', {
    staticClass: "ui top right attached label"
  }, [_vm._v("Beta")]), _vm._v(" "), (_vm.paymentMethod && _vm.paymentMethod.method === 'ach') ? _c('div', {
    staticClass: "ui bottom attached small blue label",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.viewAchDetails
    }
  }, [_vm._v("\n                        Selected (Click for details)\n                      ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "ui vertical divider"
  }, [_vm._v("\n                    OR\n                  ")])]), _vm._v(" "), _c('button', {
    staticClass: "ui labeled icon button",
    staticStyle: {
      "margin-left": "60px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showInvoiceModal
    }
  }, [_c('i', {
    staticClass: "list icon"
  }), _vm._v("Invoices")]), _vm._v(" "), (!_vm.subscriptionCanceled) ? _c('button', {
    staticClass: "ui labeled icon button",
    staticStyle: {
      "opacity": "0.7",
      "margin-right": "10%",
      "float": "right"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openCancelConfirm
    }
  }, [_c('i', {
    staticClass: "remove icon"
  }), _vm._v("Cancel my subscription")]) : _c('button', {
    class: 'ui labeled icon ' + (_vm.hasPaymentDetails ? '' : 'disabled ') + 'button',
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openResumeConfirm
    }
  }, [_c('i', {
    staticClass: "play icon"
  }), _vm._v("Re-activate subscription")]), _vm._v(" "), _vm._m(18)])]) : _vm._e()], 1)]), _vm._v(" "), _c('change-password-modal', {
    ref: "changePasswordModal"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui modal add-storefront-modal",
    attrs: {
      "id": "addSellerAccountModal"
    }
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("Connect Amazon storefront")]), _vm._v(" "), _c('div', {
    staticClass: "ui content"
  }, [_c('p', {
    staticClass: "add-storefront-modal-desc"
  }, [_vm._v("Approve SentryKit on Amazon.")]), _vm._v(" "), _c('add-seller-account', {
    attrs: {
      "show-nickname": true
    },
    on: {
      "sellerAccountAdded": _vm.onSellerAccountAdded
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ui modal",
    attrs: {
      "id": "successModal"
    }
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "header",
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('div', {
    staticClass: "ui content"
  }, [_c('div', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.successMessage))])]), _vm._v(" "), _vm._m(19)]), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _c('div', {
    staticClass: "ui basic modal",
    attrs: {
      "id": "cancelSubscriptionModal"
    }
  }, [_vm._m(22), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui left-aligned-container"
  }, [_c('button', {
    staticClass: "ui basic cancel inverted button",
    on: {
      "click": _vm.cancelSubscriptionConfirm
    }
  }, [_c('i', {
    staticClass: "remove icon"
  }), _vm._v("Continue to Cancel")])]), _vm._v(" "), _c('button', {
    staticClass: "ui button primary submit",
    on: {
      "click": _vm.applyCouponConfirm
    }
  }, [_vm._v("Get 25% Off")]), _vm._v(" "), _c('button', {
    staticClass: "ui basic cancel inverted button"
  }, [_vm._v("Back to Account Settings")])])]), _vm._v(" "), _c('div', {
    staticClass: "ui basic modal",
    attrs: {
      "id": "cancelSubscriptionNewPricingModal"
    }
  }, [_c('div', {
    staticClass: "ui center aligned container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("We appreciate you as a subscriber and we don't want to see you go.")]), _vm._v(" "), _c('p', [_vm._v("We'd like to offer you our new pricing, featuring daily ASIN tracking!"), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.$root.newPricingMessage))])]), _vm._v(" "), _vm._m(23)])]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui left-aligned-container"
  }, [_c('button', {
    staticClass: "ui basic cancel inverted button",
    on: {
      "click": _vm.cancelSubscriptionConfirm
    }
  }, [_c('i', {
    staticClass: "remove icon"
  }), _vm._v("Continue to Cancel")])]), _vm._v(" "), _c('button', {
    staticClass: "ui button primary submit",
    on: {
      "click": _vm.redeemNewPricing
    }
  }, [_vm._v("Redeem New Pricing")]), _vm._v(" "), _c('button', {
    staticClass: "ui basic cancel inverted button"
  }, [_vm._v("Back to Account Settings")])])]), _vm._v(" "), _c('div', {
    staticClass: "ui basic modal",
    attrs: {
      "id": "cancelSubscription"
    }
  }, [_c('div', {
    staticClass: "ui icon yellow header"
  }, [_vm._v("It looks like you are attempting to cancel your subscription")]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui left-aligned-container"
  }, [_c('div', {
    class: 'ui red basic ok inverted ' + (_vm.cancelInProgress ? 'loading ' : '') + 'button',
    on: {
      "click": _vm.newPricingOrDiscount
    }
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v("Continue to Cancel")])]), _vm._v(" "), _vm._m(24)])]), _vm._v(" "), _c('div', {
    staticClass: "ui basic modal",
    attrs: {
      "id": "resumeSubscription"
    }
  }, [_vm._m(25), _vm._v(" "), _vm._m(26), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_vm._m(27), _vm._v(" "), _c('div', {
    class: 'ui green ok inverted ' + (_vm.resumeInProgress ? 'loading ' : '') + 'button'
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v("Yes")])])]), _vm._v(" "), _c('div', {
    staticClass: "ui basic modal",
    attrs: {
      "id": "invoicesModal"
    }
  }, [_c('div', {
    staticClass: "ui button",
    class: _vm.editBillingNameState ? ['disabled'] : [],
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.editBillingNameState = true
      }
    }
  }, [_c('i', {
    staticClass: "pencil alternate icon"
  }), _vm._v("Update name on Invoice")]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), (!_vm.editBillingNameState && _vm.invoices.length > 0) ? _c('div', {
    staticClass: "ui icon header"
  }, [_vm._v("Invoices")]) : _vm._e(), _vm._v(" "), _c('center', [(!_vm.editBillingNameState) ? _c('div', {
    staticClass: "scrolling content",
    staticStyle: {
      "min-height": "200px"
    }
  }, [(_vm.invoices.length > 0) ? _c('table', {
    staticClass: "ui striped table",
    staticStyle: {
      "width": "600px"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Invoice start date")]), _vm._v(" "), _c('th', [_vm._v("Invoice end date")]), _vm._v(" "), _c('th', [_vm._v("Amount")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.invoices), function(i) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(i.from))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(i.to))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(i.totalAmount / 100.0) + " USD")]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": i.url,
        "target": "_blank"
      }
    }, [_vm._v("View Invoice")])])])
  }), 0)]) : _c('div', {
    staticStyle: {
      "margin-top": "150px",
      "margin-bottom": "150px"
    }
  }, [_vm._v("You have no invoices yet")])]) : _vm._e()]), _vm._v(" "), (!_vm.editBillingNameState) ? _c('div', {
    staticClass: "actions"
  }, [_vm._m(28)]) : _c('div', {
    staticClass: "scrolling content ui form"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_vm._v("Name on Invoice")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.billingName),
      expression: "billingName"
    }],
    attrs: {
      "type": "text",
      "autofocus": "true"
    },
    domProps: {
      "value": (_vm.billingName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.billingName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ui primary button",
    class: _vm.editBillingNameState == 'inprogress' ? ['loading'] : [],
    on: {
      "click": _vm.saveBillingName
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('div', {
    staticClass: "ui button",
    class: _vm.editBillingNameState == 'inprogress' ? ['disabled'] : [],
    on: {
      "click": function($event) {
        _vm.editBillingNameState = false
      }
    }
  }, [_vm._v("Cancel")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "ui tiny modal",
    attrs: {
      "id": "paymentMethodModal"
    }
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" "), (_vm.paymentMethod) ? [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n              ACH Details\n            ")]), _vm._v(" "), (_vm.paymentMethod.details) ? _c('div', {
    staticClass: "content",
    staticStyle: {
      "padding-bottom": "3.5em"
    }
  }, [(_vm.packageCost) ? _c('div', [_vm._m(29), _vm._v(" "), _c('h4', {
    staticClass: "ui center aligned header",
    class: {
      warning: !_vm.hasEnoughACHFunds
    }
  }, [_vm._v("\n                  Your current balance is $" + _vm._s(_vm.paymentMethod.details.balance / 100.0) + " USD\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "ui indicating progress",
    attrs: {
      "id": "achProgressBalance",
      "data-value": _vm.paymentMethod.details.balance,
      "data-total": _vm.packageCost
    }
  }, [_vm._m(30), _vm._v(" "), (_vm.hasEnoughACHFunds) ? _c('div', {
    staticClass: "label"
  }, [_vm._v("\n                    You have enough funds for the next charge of your current subscription fee ($" + _vm._s(_vm.packageCost / 100.0) + ")\n                  ")]) : _c('div', {
    staticClass: "label"
  }, [_vm._v("\n                    You don't have enough funds for the next charge of your current subscription fee ($" + _vm._s(_vm.packageCost / 100.0) + "). Please add funds using info below before billing date.\n                  ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _vm._m(31), _vm._v(" "), _c('div', {
    staticClass: "ui two column relaxed grid"
  }, _vm._l((_vm.paymentMethod.details), function(value, name) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "right aligned column",
      staticStyle: {
        "text-transform": "capitalize"
      }
    }, [_c('h4', [_vm._v(_vm._s(name.replaceAll('_', ' ')))])]), _vm._v(" "), _c('div', {
      staticClass: "left aligned column"
    }, [_vm._v(_vm._s(name === 'balance' ? value / 100.0 : value))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "ui bottom attached label",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n                This is a beta feature, if you found some inconsistency please "), _c('a', {
    staticStyle: {
      "color": "black"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$root.showIntercom.apply(null, arguments)
      }
    }
  }, [_vm._v("contact us")])])]) : _vm._e()] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "ui small modal",
    attrs: {
      "id": "paymentElementModal"
    }
  }, [_c('i', {
    staticClass: "close icon",
    on: {
      "click": function($event) {
        _vm.paymentElement && _vm.paymentElement.unmount()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("\n            Update Payment Method\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.error) ? _c('div', {
    staticClass: "ui error message"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "payment-element"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "payment-element-errors",
      "role": "alert"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui button",
    on: {
      "click": function($event) {
        _vm.paymentElement && _vm.paymentElement.unmount();
        _vm.$('#paymentElementModal').modal('hide')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "ui primary button",
    class: {
      loading: _vm.updatePaymentInProgress
    },
    attrs: {
      "disabled": _vm.updatePaymentInProgress
    },
    on: {
      "click": _vm.confirmPaymentMethod
    }
  }, [_vm._v("\n              Update Payment Method\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "ui modal",
    attrs: {
      "id": "addUserModal"
    }
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("Add User")]), _vm._v(" "), _c('div', {
    staticClass: "ui content"
  }, [_c('div', {
    staticClass: "ui"
  }, [_c('form', {
    staticClass: "ui form",
    attrs: {
      "action": "javascript:void(0)"
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Name *")]), _vm._v(" "), _c('div', {
    staticClass: "two fields"
  }, [_c('div', {
    staticClass: "field focus"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.firstName),
      expression: "user.firstName"
    }],
    attrs: {
      "type": "text",
      "name": "firstName",
      "placeholder": _vm.$t('First Name'),
      "required": "true",
      "autofocus": "true"
    },
    domProps: {
      "value": (_vm.user.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "firstName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.lastName),
      expression: "user.lastName"
    }],
    attrs: {
      "type": "text",
      "name": "lastName",
      "placeholder": _vm.$t('Last Name'),
      "required": "true",
      "autofocus": "true"
    },
    domProps: {
      "value": (_vm.user.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "lastName", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v(_vm._s(_vm._f("translate")('Email *')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    attrs: {
      "id": "email1",
      "type": "email",
      "name": "email1",
      "placeholder": _vm.$t('Email'),
      "required": "true"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('button', {
    class: _vm.addEmailAddressInProgress ? 'ui right floated loading button' : 'ui right floated primary button',
    on: {
      "click": function($event) {
        return _vm.convertIntoUser()
      }
    }
  }, [_vm._v("Save")])]), _vm._v(" "), _c('br'), _c('br')])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "ui modal",
    attrs: {
      "id": "deactivateUserModal"
    }
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("Deactivate Users")]), _vm._v(" "), _c('div', {
    staticClass: "ui content"
  }, [_vm._m(32), _vm._v(" "), [_c('div', [_c('div', {
    ref: "dropdown",
    staticClass: "ui multiple selection dropdown"
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "selectedOptions"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "dropdown icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "default text"
  }, [_vm._v("Select Users")]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "-1"
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.tenantUsersForDeactivateModal), function(u) {
    return _c('div', {
      key: 'deactivate-user-' + u.id,
      staticClass: "item",
      attrs: {
        "data-value": u.email
      }
    }, [_vm._v("\n                            " + _vm._s(_vm.formatTenantUserDropdownLabel(u)) + "\n                          ")])
  })], 2)])])]], 2), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('button', {
    staticClass: "ui right floated red button",
    on: {
      "click": _vm.deactiveUsers
    }
  }, [_vm._v("Deactivate")]), _vm._v(" "), _c('br'), _c('br')])]), _vm._v(" "), (_vm.paymentDetailsSaved) ? _c('div', {
    staticClass: "ui success message"
  }, [_c('i', {
    staticClass: "close icon",
    on: {
      "click": function($event) {
        _vm.paymentDetailsSaved = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("Payment details have been saved successfully")])]) : (_vm.error) ? _c('div', {
    staticClass: "ui error message"
  }, [_c('i', {
    staticClass: "close icon",
    on: {
      "click": function($event) {
        _vm.error = ''
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("Error")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.error))])]) : _vm._e(), _vm._v(" "), _c('button', {
    class: _vm.dirty ? 'ui primary button' : 'ui primary disabled button',
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "ui button",
    on: {
      "click": function($event) {
        return _vm.$router.push(_vm.$root.defaultPath)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.dirty) ? _c('div', {
    staticClass: "ui basic left pointing label"
  }, [_vm._v("\n        Save for the changes to take effect\n      ")]) : _vm._e()]), _vm._v(" "), _c('br'), _c('br'), _c('br')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('span', {
    staticStyle: {
      "color": "peru"
    }
  }, [_vm._v("Sentry")]), _c('span', {
    staticStyle: {
      "color": "steelblue"
    }
  }, [_vm._v("Kit")]), _vm._v("\n           Settings\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row marginBotton-1"
  }, [_c('div', {
    staticClass: "sixteen wide column"
  }, [_c('h3', {
    staticClass: "ui horizontal divider header"
  }, [_c('i', {
    staticClass: "sliders horizontal icon"
  }), _vm._v("\n                  Manage Storefront (Seller ID)\n                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui column centered grid",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "column row sub-heading"
  }, [_vm._v("Set up and manage storefront(s) to mirror your team structure (e.g. agencies may set up by brand client, merchants may set up multiple storefronts, and brands may set up by product family).")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sixteen wide column"
  }, [_c('h3', {
    staticClass: "ui horizontal divider header"
  }, [_c('i', {
    staticClass: "sliders horizontal icon"
  }), _vm._v("\n                  Manage Your Users\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "six wide"
  }, [_vm._v("Email")]), _vm._v(" "), _c('th', [_vm._v("First Name")]), _vm._v(" "), _c('th', [_vm._v("Last Name")]), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sixteen wide column"
  }, [_c('h3', {
    staticClass: "ui horizontal divider header"
  }, [_c('i', {
    staticClass: "sliders horizontal icon"
  }), _vm._v("\n                  Manage Storefront Teams\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column row sub-heading"
  }, [_vm._v("Select one or more storefronts, then choose users to grant access to "), _c('strong', [_vm._v("all")]), _vm._v(" of those storefronts at once (or use Seller account Permission under each email to fine-tune)."), _c('br'), _vm._v("The table lists teammates who already have access to at least one of the selected storefronts.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sixteen wide column"
  }, [_c('h3', {
    staticClass: "ui horizontal divider header"
  }, [_c('i', {
    staticClass: "sliders horizontal icon"
  }), _vm._v("\n                      Manage User Alerts\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row margin-top-2",
    staticStyle: {
      "padding-bottom": "0px",
      "margin-bottom": "-5px"
    }
  }, [_c('div', {
    staticClass: "sixteen wide column"
  }, [_c('h3', {
    staticClass: "ui horizontal divider header"
  }, [_c('i', {
    staticClass: "sliders horizontal icon"
  }), _vm._v("\n                  Manage Email Channel Alerts\n                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row marginBotton-1 margin-top-2"
  }, [_c('div', {
    staticClass: "sixteen wide column"
  }, [_c('h3', {
    staticClass: "ui horizontal divider header"
  }, [_c('i', {
    staticClass: "setting icon"
  }), _vm._v("\n                  Account Settings\n                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column row sub-heading"
  }, [_vm._v("Manage your account-level email settings affecting all users. You can connect a "), _c('br'), _vm._v("third party app, set your instant or batched alerts and alert email settings.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "width": "100px"
    }
  }, [_c('img', {
    attrs: {
      "src": "data:image/png;base64,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",
      "width": "70px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "ui striped very basic table"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "100px"
    }
  }, [_c('img', {
    attrs: {
      "width": "100px",
      "src": "data:image/png;base64,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"
    }
  })]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-left": "2rem"
    }
  }, [_c('a', {
    staticClass: "ui labeled icon button bordered-button-green",
    attrs: {
      "href": "https://myaccount.google.com/permissions",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "google icon"
  }), _vm._v("Google Settings")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "width": "100px"
    }
  }, [_c('img', {
    attrs: {
      "width": "100px",
      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAaQAAADICAYAAACnDZWgAAAgAElEQVR4Xux9CZwcRfX/e92zu9kNhJzkIEASThHQkAPklEsFBQ8gch8BstmZJYSQnZlNQAcSkp3eXCQ7uwkq+EdFkwCiIOKBiPrzREEUFZR4QDiSAOHIXtPd9f+8nu7dnp4+qmd69uzyB+SXqXr16nV1ffu9egeCR0ulUsLkyZPF/x0uTtldoYxTUUEaIqKg/ddoClMZ/VnQ/6vqvzv3ExlAFgAqYOjSzMmqV0a05l4Z0Z/NcjpcGftWw+nz/gMIWr+whRIIJRBKYDhJIO/ANC/8khdSlRPem3AYqpGPK0y9jClshhARx6mgAmOAzHJmIiAgYt5Byhhz6EeDzVOz4UmTMSBJMGDIGIPpIya8K4BwU2LORdutshxOmzJcayiBUALDUwK2gLTglxsOqYCqcwCE5e3ZzkP3dL4nvK90YmdXJygGxNBhamqIBEnUDJI5yKKD1tJR62H0pt+op9ZriNCkNTNV1SHbvP7cqu3WTmM+fegcGBmpfk2VO87tfuJf/0ilUurw3JbhqkMJhBIYjhIoAKTbfnvfEW9nu3+yp33v1H+8u1N8P9uhHaKhDYl/exSAsMNQDYZ1wRJ8XX7Y6TBx5BjozmZ3ggp1ybkXP8o/a9gzlEAogVACg1sCeYB0+x++PXNP17ubXtq785Qd776Rp+8M7mX2Lfd2gGQH6HaANGm/saCqKnTL8k7ozl7Q9eMX/5JKpeS+XUE4WyiBUAKhBPpeAj2AlPjVPR/erXb/+oU3d4za1f1+3g1P37M1uGcsFZA0kx9jICvKLqaqDck5l9w/uCUSch9KIJRAKAFvCWiAtPr5x8b8Z+//bnv2zX8u2dX1Pgjo6OvgTTHsUXhv5mDyNGtI9OfLDjsdSEMyAI3+m5WVPYqsXJ594m9PhZpSuLlCCYQSGMoSQHLrfvX0sclXOt6+86W9O8UQikp/3MVoSHaARJxooKSo7wFT70jOvnhd6dyFFEIJhBIIJTAwJYDNf75/5DNvvPbM3/buPHqf3DkwuRxkXPkCJH1tNMaqIRnL1jWldxmT67p+8PftoaY0yDZEyG4ogVACXBLARb/YfPYf3/7PEzs/2BMJTXVcMvPsFDQgGRNmZbmDMXZrcvbFbZ5MhB1CCYQSCCUwyCSA1z21sfZ3b764uUPpDh0ZAnp45QIkYq87K7+tKvL1h/8XH503b54SEMshmVACoQRCCfS7BPCU7zfe9fr7e5b1OydDiAErIDnFcJmzXbiZ7KyiyWazHzAVLg/jlIbQpgmXEkoglADgrIcXr327Y9+S0JkhuN1QbkDK3SnJrzPGLu/6wQu/CDM6BPfsQkqhBEIJ9J8E8ENbb1rfKXcuDgEpuIdQDCCpLJepwez27cVRd3f3XgT2ycSceb/36hv+HkoglEAogYEuAZz+YPRu7MouGuiMDib+eACpx1xnSR3kB5D0O6WdKlOi3T/422OhpjSYdknIayiBUAJWCYSAVIY9wQNINK05MFYBBlf41JAM1ru7s+8CwwuTcy76ZVi6ogwPNCQZSiCUQJ9IIASkMoiZB5DMYEQslAJIOU0pu4sxdcVh/4a20PuuDA81JBlKIJRA2SWAMx5euAE6lJvLPtMwmcC3y3eJJjtDrHruu3aVqZ9vnH3Jj4eJuMNlhhIIJTCEJIAzHly4DrqUW4bQmvp1KXZ1nRwzfefsdlozyk/4vUMyAxJpXYqsvsFAXdU564VMCsN6Sv26GcLJQwmEEvAlAZzxcN1a6JCX+BoVdnaUAI+GlFdtlwAJARRVhSsOP8OXl52ZCfO8WVl+jynq5xtPnPez8FGFEgglEEpgsEgAD3souoZ1Zm8dLAwPdD65749M2lHQgESks7LyNlOhsXHORV8JHR0G+q4J+QslEEqAJBACUsD7gAuQqFS7pQyvwoLTkAysozRD3XLHuamPXfWngJcZkgslEEoglEDgEghNdgGKlMdclwML/eLIdLkUNCAZy8rK2TcZw9hh/1YfCb3vAnzYIalQAqEEApdA6NQQoEh5AMnu/ojwqVyARJgny9nXVLnr3MYTr/g7Ijql1gtQEiGpUAKhBEIJ+JdA6PbtX2aOI7jMdYZ2ZFBhOY2JUgcV69RgB4RmJlWmgqyoO0HBm5Jzv/BICEoBPvSQVCiBUAKBSSAMjA1IlDzakWauM98f6QkE6e8UxuDKIr3svAApZyYEyGazr2G261OdP/7XC2GaoYAefEgmlEAogcAkEAJSQKLkBiSCBt3Vu/cqqfyAZCyzu1vehQxXJude1BJ63wX08EMyoQRCCQQigRCQAhGjrvlYaDkGxJp/wNzYcmtIJgshyLKyR5GVy7NP/O2psBx6QBsgJBNKIJRAyRLAGQ/VrYdOeXHJlIY5AV/3RwYg6a7f5b5DMj8ampoxFRRF/UCVoaX7xL8uDzM69P3mTaVS+3V0dCxkjF0FAJMAoBoAKgBA1P8xmKKqwJ0A8AEi/iQSibTdddddv+17jsMZQwmUXwKh23cAMuY211njj3TtiFgop1ODFZCM/1+Wlb2qql7f/fgL3w81pQA2ggeJ22+//biurq67AeB4ABgDAEKRs+4FgP8KgrBxxIgR94fPrkgpDvFhqVRqVEdHxymCIGi31aqqMkSkDxxVEASmqurbTU1Nzw4kMYSBsQE8DW5Asok/MtzAiwUkHocGJ0DSNCVZ7WQqSzfOveSO8E4pgM1gQ6KhoeFaREwCwBElgJATc28g4uOiKN62atWq18uzgpDqYJTAsmXLPirLshvg/J8kSacOpLWFgFTi0/ANRjSf6Q6pPwHJpCm9rSC7/IiX1Z+GwbMlbgjT8IaGhtMAYD0izgqOqiOlDxiyzSOrRy5PpVLdfTBfOMUAl0AymZypqqpblpYQkAb4M/TNnm9AsgGjUkx2fjQkp4hYXVN6jzH15sY58/5fqCn53gZ5A7Zt2yY+88wztwFAqjRKRY3ewxi7uLm5+emiRoeDhowEBiUghdm+S9t/RQOS6f6oWEDyA0YWxcx20dms/IYgwgXxmRf9MQyeLW5fNDY2jlMU5Q8AML04CoGNukmSpJbAqIWEBp0EEonERxhjz7kwPvA0pNDLrrR9Viwg5aUQKtKpIWhA0jSlrLKXoXBJ45yLflqaZIbfaI4v0j4VCiJub2pq+mL4cdGnYh8wky1btux4WZb/PKgAafqD0buxK7towEhxEDHCDUY22b1z5rNeI1oxcUhBA5LGkZ5miKnqFYf/B34V3inxbchkMnmRqqoP8vUu6JWllIOI+G/G2A5E3AUAI1RVnYKI5JE3Klc1S3MJ99vukSSp1u+gsP/gl8CyZcuOlWX5LyEgDf5nybUCbkAysjPoVK3aEf11uQHJT0ZVDZSyyrsqU7+4/MQv/ohLGMO4U0NDwzJEvMunCBRBENoOPPDA+JIlSzp4xjY2Nh6tKMoTAHAoT38A+Gc6nT4q1JA4pTXEuoWANMQeqNtyfIGRWRmy3B0ZcwwkQDI0JUVRdwHgLZ2P/eXB0HPLfjfEk/EGUEHysfX/KYrihatXr/6HjzHWrphMJu9QVXW5ixv5/yRJmpbv01nCjOHQQSeBQQlIMx5euAE6lJsHnbT7meGiAclcD8m0Br9xSOUw15lFSloSWYkUWWlXgF2/fM4l3+lnkQ+46ROJxGcZY4/wMIaI+1gFmyOtlP7O05+nz4IFCypGjx7dBgDXm/sj4s4dO3Ycun37dgqCDNswlUAikTiOMfa8y/IHoFPDgwvXQZdyyzB9ZkUtWzN/0b2QqTm6VFvMdTllqbA3aUiXTT0RDho/JZcR3KPx9OHhz3seSjPE9jLG7hz5m9daFy1a1OU1Zjj8vnHjxqpXX331XQCo8lovIn59x6wdN2yfVx6AiMfjHwKA3wHA/oj4ant7++GbNm0Kn5PXgxnivw9Kp4bQ7dv/rvStHZmBywFsSEM6beIxMHfyUZ6A1FdgpEGnzq8sK50IcGlyziXf8y+xoTciHo/v4HHtFgRhaVNT09pySyCZTI5RVfUbNTU1V6ZSKUotFLZhLoEwU8Mw2ABOYGDVaTQtyFJmgvyk3MBsWvVY+NwRp2nuVG6tbwHJ4IRpmhIwdtuMf6ubh7P3XTKZ/JSqqj/02u4KstvXpptXevULfw8lUA4JcIQhDDyT3WEPRdewzuyt5RDIUKTpSzuyqXtkJxMDzCIKg/lHnQMja/brZ0DqhdeceRIAETUwVVX1nWxWufC2k+b9aig+X541xeNxctOOeHw0PNrc3HwhD72wTyiBckggBKRySHWA0eQpM5E7w/VD3QRKdndH+nmvrTKrKnB0zTi48MgzAgMk79soZ4g0wqdyKltOb8uVrlDeVJlQf/i/le8ON00pmUxepqrqAx7b8l1JkkYPsK0bsjPMJDAoTXYzQqcG7m3Kqx0VAJI+gxcgaRpIVoGbZ34WKkT7D/C+NNdpGKQa4bs5aEMUcsGzsvp6lnWfe/ucy/42jOJcMB6Py14Zu5UKZdrau9b+l3tjhR1DCZRBAoPUqSF0++bZC77ByGyuc7g7MmtHBg+yqsCcsYfBaQcfByLml8vxC0Z29PnWmnP5zgFQbkTOt8EKSso7CHBFYvbFTwwHUEomkzNUVX3ZQ4ZPS5L0cR45h31CCZRTAoPS7TtMHeS9JXgdGQxK9uBlbzwrcIZgDLraO+HTh82B4w88LI85v4BUjLkuF39kNOy5O8qrmZGnKSmvQVb+TNePX/xzKpUyD/YW7CDrkUgkXmCMHePC9r6adM2osALvIHuwQ5TdQRkYGwKS+270A0Y9ffXS5JqSoTnb8YGRwYlK9zRdMnxs9GFw0ozjobKiQnMo6AtAMkuDwClnotMKn+cJiv4+pzmR+U55HwEakrMvuWeolq5YvHjx6MrKync8zq7vSJJ02RA93zyX1dzcPDKbzY7obux+Z6CBMlVPraqqEhuTjXsH2h6lcvapVOoDTwH77NCXgLRt27bKP//5zxPHjRu3hzcVlt1yMASkAAEpv/JeD2E/gGSAjioroOzrgjljp8FJR50AIyJVnu7geWDic/Ma4NKjG+l3RTnvOlKJdDd2vYMZkFSVwBL2KLJyefaJvz01FEtqx+PxuXrwqbNka+BgKSW9WoToB92QeDz+ZURcwhijxK92jbRl+oeyRWzsqOlYuSm16b0+WCgmEolbGWOUVml//b7PGklBO5p4o4S29xx00EENfRHwnUqlatrb278EAIv1RLmULNcuymOXIAgLm5qavmuW15YtWyqc5Pf6668z63tXTkBKJpO3qKp6BwAYLsHmdZi/YJ8UBGFBU1PTf3iePYblJ5zF5Es7ssnI4BR3pB3+DtOa5yQgY1kVsm/vgxkVY+FjH5oJUw+cDKJYTNLn3ISqNnMxxjx7hg0LH/GtqOw9JittXXNfWDbQvpB5Xga3PvF4/NsAcKlLn99KkvSxUucZyONTqdSU9vb2/wOAg4vIPK4iYoeqqtHm5ub7g15nKpWatG/fvscQ8Vie7BmW+emFeIcxdk1zc/NjQfOme7tRQPlBPuX2PiJekU6nHyWePMINfi1J0ilm3oO+Q0qlUpGOjo5fMcbmeDn22Mj3A0EQ5jU1NVFyYMeGYaYGf4Bkd5QXaEA9Ht/OB78tHZssDkRblVVQ3toHkX0yjBo1Cg4dOwmmHjABqquqQBBEzePAPFRzREAE+l9vy/XpCdilH5D+j+6J9P9H75zrY6KpkyFtKdfToJvrQyZGY0wW1fd+u+fZKc9f/Y19Qb/Y/UVPrwDb6RZ7JAhCS1NT0039xWM5502lUpXt7e1bAYDiqvI9bYqYmHLtAcCn0+m0W60eLsrxeJzSJX2DMXYeAFRyDXLv9D9RFOetXr2aUjGV1hhgPBH/OQBQKXuveHe3uZ6SJOmseDxO2qat/Bljf2hubiYtvqcFWaAvkUjcxhijKsieqbI8hPbbmnTNKU4frBgGxtqLz7d2RGQMlCny7sh5TgZMZaC2ZwHeaofuru58phXdl0AHGE0zI/CQ9dyaEbH3zwXvhRNo2r0/7n1VRQGsFBVxxpQxe66/9/3S3uaBMzqRSBzAGHNNxyMIwsVNTU0PDRyug+GksbHxGEVRKIHsEcFQNH0iMSY1NzcniqWbTCY/rqoqaVuksQXZulHATLopvaRYorHltx46MisSqE0sloZlHJWB+aQLrT9LkvRR8+9BxSElEokHGWMXBbQOIvPquHHjjkkkEgVnRAhINlIuCYx0en7ujQwWnF3Le5FOfr8DcB8lCgAQFKAgVc2EZx5Lmgz9PUR0UJHzgUQzoNOdEG8zAM+tP6lKggBMABknjR87lABp2bJlE2VZfsNVXJVwtLRSepFXpIOh362JxKkiY5QiyT11SGmL2SxJUp1fEvF4/GIAuFe/J/I7nLf/I5IkfZ63s9Hvtttum97d3U1Z3UvVJvxM/VdJko4zDwggUwPdxz3AGHMzVfvh0dz37ZqamoNTqVS7+S9DQOIEJMc7H3NGBhMtv4DkHufUO7tmIvugE9QumWxledwbGMNslBsNvNDwykYQdPOb0Zep+m+Whdqu26Bvnt/4O0FQYOzooaYhHcIYcwt0VWpqakYE5cxBX7aKolBZCWqaAdbGVGNczFMfze1E708mHesOoIdrvjw0aK407iesr0EymZyjqiqZm2qKPXF4xwmCsKKpqYku+7laY2PjxxRF+RlV1eUaUEInxpivFFBLly4dKQgCeWM6OiCUwI7b0L9IkkTVhXtaqYAUj8frAWBTmfglsgUFJMM7JIu0S9KOeoJIS787Mk6ZHHtmejl7YPb9ToDOrH4UaZG3AAICKgzsAKnYTZVzgnBosg5igun8EwUZDxbG7J63PXA31mLXUOq4xsbGIxVFcdN+3pIkaXyp8xjjGxsbT1EUpey5AqksRjqdvs7KdyqVOrC9vf2vADCBc020EciDjv6hu0MCigMBYCTneIhEImetWrXqKa/+uvn0dQCo9uqr/052azK3kp2b/lyBiNUu3oEFZP1kbOfNAm9MQvdpjDGqGEyeSuQVOMan40PuhGDsj83NzbPNzJdyh8QBZuap6Pn/CxEJiN9njFHaLCoO6flOIOLd6XSavA61FnrZmcTqB4xyMNHjvZC3iYPQjnphyHwx1Tur5tW2rwtYpwxoAAJpLPRnMrFZMEy7U3JoaNG0OF903WPP0ltAGacOLUCKL4/PhaxWb8ip7ZAkKT+KmVeINv10DeDXJZDgHfq8JEkfMXdmjJGZ5hcAcCoHkX2IuG1fNbutJSW9Zu2fSCRqqY6WDk6e5GpqasZ4lc6Ix+PkPuxZwh0RCRzvra6u/nIqlcpzN0+lUkJXV9eFiqJs4KFFFu6amppxXrw1NjYuVhRlvedCAcjmvi0SiTSsWrWKwLWnpVKp0e3t7eROfYNP7fQ3kiSdbKZVbOqgxanFoyvbK9/icGBRGWMPjBw5stZqeiM+9AKW3/Qy+bJKdmTzyuZ/aoAUxiHlHqEfMMoDHIsjQx5QmXaH242Nt7nOiLTVedXpCoDQ9UEHYHdvYVBNQxJ1UBKEnPFGVoGZtRgTX8WCEZGw1Z6GIiB5xCAxxl5pbm4+hOMg4urS2Nh4oqIov+XqXFqnPZIk5WlBDQ0NNyMiHdRujbbzmtmzZzfyJNeNx+NXAcD/8/I0Q8SfptPpc50mTiQSpzLGfum1ZER8KJ1O0x2TZ9Npkmbmmr0dEd9Pp9NOMVewbNmyybIsF4CylQFE/GN1U/Vcr7AI3bOTZHaF5yJyHX4pSdLpFkA6Vpblv7iMty0/kUgkNjLGvDxGXxAE4bSmpib3YPGcpyFp+3lgaeHp7dmzZx9IeykEJF0yvnPV5ZAn1zy86sxdrZuDH4xyk9gBm9zeBdBJOT89TpEiNSE7qj13TpYfURRlOAiGlMmuoaHhBDpIXKT7viRJjoeV13Ox/r58+fK52Wy2dLdj74nfkSRprLlbPB7f5WWqEwRhblNT0x+8yff20A9sOhzHuY1zoU2JbT1TUyHiwnQ6vcUPbxRw+vLLL7/t9SVfWVk5Y+XKlf+2ox2Px0mrJPdux4aIq9LpNAXscrdEInEpY4xi4LxaQQ7FYgJjOczTxMdWSZJ8OTrE4/GfAsDZLov4hCRJPwkBKQjtSJdysKY6ImrcVffeWTvNIe/rBOjq1ZS8dq/2uxZu5MPbzkR0OAGSXiL8bx4H6VjPr0WuhwLQX4BE2RcAIOXGZiQSOWfVqlVPci4lr1sylZymtmvJad1imR6XJOnTVvo8WiMirkmn0w3F8Ebpe9rb29/0MJO9KUnSJCv9pUuXHi8IgntMlQBrpSZpaTG8JZPJTaqqkoOBW/uFJEl5dWuKAaREIrGOMXaLy0TPptPpWX6SKW/cuLHq1VdfXQcAURe6/5UkadqwB6SiTHU2Z7hfMNLwwAEMemnlJ8Vz9PTTfmCgdGUBKFaJt5UASI5TiCjD5KGlIfG4fTPGTm9ubvY0J/E8Gp7Dl4cOR588Z4x4PL7b7SKaMfZcc3PzTA66jl0SicQFjLHve4D7EU1NTf8y90kkEnsYY27a1bOSJJ1QCm/xeJwcPMiV3LGpqrrfmjVr8oK+E4nEWsaYY8wSIv4hnU7nBa364XMb2yY+k3jGywTyK0mS8jS0YjI1xONxClqe4sQfIo5Op9Pv8vC/fPnyk7PZ7HY3emY6iHg+Dud6SH7AKHfkW5wYijTVec9b6FWXm9++mempHd3AyCXc1JnulOhuKahm58XX43IugAyThhYg6ZkKujzk9yVJklYEIWM9oNG4xyFtwnDltuYLM/LFGSq0ua/Bils6oxclSTqaOqZYSmhPtNOh5+T9wmpqakYFkQR06dKl/xQE4XCXQ++qdDpNl+Fau+mmm6qqq6spU4ZTY2pEPX7NqjXkGVh00x06/gQAeQGmZoKCIJzZ1NRE7vBa08195DTh6IKuqurJa9as+U3RjOUcBM5jjD3uQqMgdZVfpwbd1f/3Ls9leTqdXuW1jng8LgHA9QCQZw72GgcAPxyWbt9uZirXQz9fYdHk66QZ5X6zb+6AVOhV55cWk1UtVklzZNDJ8TovaGDjkeQEyTJo6aMAA3KyAAEUNnL/IRWHRPKPx+OUg8sxUt7rQp7jZQy8i+6+TWYop9YT+JlIJC5njH3L5TD6IJ1Ok1tyya2xsfE0RVHozsWp5QXLcqzjT5IkzSqZsdzBfwdjzC0m6kFJki4x5orH4+Rq7Xaf9mZNTc2UIEqz6HdoTm9ngQz8ZmpoaGhYgYiUHsi21dTUVKVSKUuamFzXZDI5jTG2EQDO8ONSb0yEiOsjkcjdwzIw1ltDyX8eTu7dboDk16uuEHR6KRRDS+3Mgtqdr+UTKOVAKjhtqWDnIiqsZr+hB0jL4ueCDD92ObDfq66unmzn/hrEQVkMDa9y64i4OJ1O3020GxoafoqIjpfOxVzIO/F8yy23jK2oqCC3YqeW5/2VTCavVVX1Ppf+90iSVFuMjKxj9CwLdM/ldPATMI8y7lC8nA4Q8fZ0Or0yCN7i8ThpYk4fBSUHxiYSie8zxi5w4lWSpDyZ6NrhPAAgU6ebw4ITydcQcSUifse4fx12gOQXjPJAx3KOB6kd9QKS2ZGB/hbdtTAXcFG6ZWAUPGtuFj8JA6S0/5aS/tGYQ0CFVQ89QOIx2yFiIp1Ok7liQLR4PE53Wo7xRFVVVceuWLHiBWI2kUh0MMYczU6shk1uTjW7p0/iXPWCLQsqRr882vZLWyeRd7fV0NDwLUS83OVj4DPpdPoHnNN7dovH468AwFSnjjU1NRVGVo5EIpFkjK126isIQsF9mCcDDh0SicR9jLFrHX4uOXVQPB6n2DdbEy8i7k6n0xTsTB8vhyEiudXTR8D0ItbzS0TcnE6nH7COHVaAFAgYFXlvpAGOC3jksM5qrnMp7qc7MjhtBvpZK+rXmQVGSVbpL0g7srp+W28lcozmyFIwrd2f3XbgEAWkSy65RJw+fTpd5rplH+i5kyniJQ18SDwed1OFZUmSetLbeJiDmCRJJWf5Ni8wkUi862LaYel0WjS0kHhci2PJK61gpoWIHw0ic7hBMx6PkwkuL+uBeb6amprqVCql3WklEokNjLGbnR6eoijT1q5d65Z2ivu56zWIyFvNrj0nSVKew4lfk108HqfQBifHEArg/Rwixhhj9HHgGrdlwyBlo/h1JBKJr1q1iu7pbNuwcWooCozoMDYObM6Yo2LMa/nGud4Ji6FlPOW8sd0KKJ3dOUDq+cHs9cD9Tnh3JC+78eqQikMyFp1MJhtUVfXSgM6RJKkot2hv4fL30IvBuZUAyQuKjcfjZN91KrSVlSQpiNIOPQtYunTpc4Ig5GWJsBz6+xsOFPF4/CW3bOM1NTUTUqnUHn7puPeMx+PkPEDlLJzaKEmStEzV8XicvPIK0i+ZBh4sScEUbVy2bNmnZVl2qtf0e0mSTjQz7NepIR6PU5wY1ZMKqtEh8zZj7GuHH374bbW1tZ4uwDjj4YUboENxRPigOOsvOt5aiTNndl51xdDzivUpdPMmnoo31dkCWbcMZMJzbUEEzoqCDOOVIQlICxYsqBg92tXUROJ9I51OT/ETp1GOd8OrZAAifjedTn/BmDsej5MXoRPo5GlTQfAbj8cJQBzduGfPnh0xskC4mZKIF8bY4c3NzXTvE0iLx+NUhNAxs4DZ9Tkej1MS3IVOE4uieNTq1asJUEtujY2N1ymK4uSWXpB1wa/bdzwep2Dsot3TTQvsRsR/CYJw0erVq//hZ+FDOg6pGPDQN3ifaEbaXNrTMkOIc0YG48EWuy4lKwOQS7hTMwDJIc2Q47hc5b9cG8KARMvjiDgHRLw/nU5f4+dFDLIvh5s01NTUkANGz51QPB6nTAWU2NO2TZo0qWbJkiVkdim56ZfhjndIiNiZTqd7kqcmEoltjLEezzYrA6Iofnz16tVPl8yYTiAejxO4zXChZ9aQ1gDArU59BUGY3U+UL+0AACAASURBVNTU5Jblg5vtRCLRzBhzCq4tOTC2oaHhKUT8ODdDhR1lVVXXrlmzprHYstRDFpCKPbRz8KCfrpxmOiukmJ+Tfz7cXCWMKx17Yx6PiQ/JJTyraPdLgiiAahTxK2EX5q1XRBnHDk0NyVinx32LsR3mSpL0TEBi5SZDsTTJZPKvjLFjXAa9IElSnmkmkUg8zBhzrP3jJ+O1F7PLly8/KJvNvurS7xlJkqhMttb0JK2bnfozxpqam5vpECy5NTY2jlMUxc38p6TTacoYrr1uDQ0NNyDiV5wmRsT6dDqdKZmx3McQaRtHOdAqOXVQPB6nFEW+UgLpvLwpCMJ5TU1Nz5a6ziEHSN7mMWeRaWPNd0amnKZBe9TlAZ+RDE9njQdY7FbBO47S/lCW8BCQint9EonEvYwxt3sD7fHW1NQcGOTdBg+3Xoc30UDEL6bT6W1meh73E9Q1sHx9yWTyU6qqUuE/24aI96XT6fnGj7embh0vtouURcKpFQSF8sjKrk8ikVjKGGt2Gi8IwmNNTU09rtGJROJ0xpibdvayJEmOQcB++IzH46RVOtVZKllD8lq7hVeVQgGqm6q/7JUo1s8ah1T5Cf/aSL6o7OKN3PUV5+BX7UTi8qrL97V2BT6P+CEnQLLlg0pUkLZkFOYzm+uMP+cnGbfdV0z3vaLvRc1tnLJ9jxnaGhKVL2hvbzfq/ri9b3JFRcXhd911VyBeVl4v9pJkw0URFSlVi5sD/3PpdJqSxeZtF31NdI/k5D1FAFtZahFCfZ4dbmUfyIurubm5J6EojwkyEol8ZNWqVc97ycjr94aGhr8jopa9wq6ponrymtW9WRfWrVtX/cYbb1DtLzcvxDmlass3pW49prpd1Fz0HdqvJUnK80T0e4eUSCQ+zBjzynbxvCiKl6xevZrKRQQe0DgkMjWUohX1AEeAmpE3GFnvjLQRrk+32DW6giJpSl0yCFR6nFzEiwiYLeCaCvSNloekU4P5IFi2bNkJsixTmhUnzzSju4yIV1g1Eq+D0e/vjY2NcUVRKK2LFz9aVmU7+vF4nEoJUHE1p1ayJtLY2Eh1iL7ntr5IJDLFWifICygAoMAM6VeGiUSCXJpbXMaxvXv3Vt1zzz153mLxeJxMdlS/yLYh4iPpdNp3KXQzMa87PsbYH5qbm/McEvwW6NNTJ1EhyiN4AdmvjKl/PB6/RpIkKq1R0AZ1HBLPAeoF4ba1jTzhIQjNyHgWvfmIitWOeE11dhtAVRVg3QrQ9zKHQlRAwgaQFBCrh1ymBjvZJZPJb6qqylWvhgqZCYIQ5U1MyfuiL1++/FBZlr/KGDvHawwD9tVmqflGp34caXO4K7s6AB7df1BMkWMlUadaRl551vSv9TskSaLidr6bXh6Div+5ube/IklSQd0rDvdq+uira2pqcrwHc2M43hi/DhT3pK8A8GdJkvJy8PmNQyIeksnkSlVV3Upk7Mlms0etX7+enGB8t5sabz2mWtE0vRdFUfzC6tWr87LoD1pAKhWMCg7SABwY6Ol4m+m0XqYHWZpXnZWadYe4yynHh0omui6Z7hbyhpOMmIv1B0mrsup1ojBsAEk3P9EB65bAtEemernqNaqqfsWaMdrvm02eajt27PiSHpTJk2Puv2qNOndNag3VO7JtqVQq0t7eTlrSfi78kJvm8ZIk/d0Pz/F4nDIfUAyNY+wR0YtEIsetWrXK1mwUj8cpi6KbaYw29BckSXrED296WXRyGCgoLWGmo0bU4+wSuOpZPEizoLLdTq0dES9Np9OP+uGNp/SJTq/kTA1ER6+HRCDhqGkzgK0ja2qudspr57Q++njKZrPk+GB4czJEXLZjx47m7du3a7VzBiUgeYGRq8ZgPUALsaGohKl8YGRBPf3JeWpxnndR9luAB4yMkQRKlJRVSyvNAChZqmsjjcqGLybisAEkkk8qlRrV3t5O1V0/5OOgoQv65kgk8kOnw9eJFtXeiUQiF1PNGsaYG3CYSSiCIMzh8YLidNigLOOfqKmpeYonaWg8Hj+JSnYDwMFuMkLE382aNesUpyq0iUTiRsbYPV5yRsS8bOFu/Umeoij+kiMhaEF1XTNdfY1eGb07UcRF6VXpr2phhi6NzGcNDQ1nC4LwI45S4kSp5Fx2BjucFWOpBPuiVatWuSXv1UjSWhobG89QVfW7diZhxtjPRVG8rqmp6T+D7g4pMDCybgeOlECacN03keOvhfFGvV2LpenGj5ecrCshHpiiaqDE05yyhzPK1CBWj91z/b1aJPtwaLoXGB1GxXhTUd60+yECT6KCu7LZ7HuCIHRVVlaiLMsVgiBQfrlDVFX9IqVuAQAtn5iPxkRR/Nzq1atdaxD10MuVnCaXbMeaOEZf8jgDgFtGjBjxmjWpLGmPXV1dR8qy3ICI5JHolSmRnCamplIp1zLg8XickrJ6lTWgTfwcY+z6kSNH/sNI82OWmf61TuZLrgquoih+yC3Ik1JLzZgx41nG2HEcz+YFxtjVOm/t5v7kwDFy5MjJ5OnHGOMqw64f+n9sbm7OS3fk9w7JBEiHMMZIA67xWMvbgiAskGX5l2vWFGretJYRB4w4RMgKKT3dkBs58to7f1B42Xkfrt7uHo4mOhKRlrLNXSMIXoshil7ZGNwhsHggKxypARL9ixwdOEDJEZAigowHZIe8U4P1zdIrjpKTgx9NiePsKqkLmUSuTafT9/uhkkgkTtVdmXnz15G55Q+I+DfGGAEGHcpnAkAV77yCICxpampa79Vfv+shwOTljUj+HyI+R1k0qNYRY+wstyBgKw9UULC5ufmzXrylUqkR7e3tdLfSE9TrMoZkRmYxKmvyF0QUVVU9AhGpxEkxaZp+I0lSXnYJjrutguwOPaC0LPFpJjOnNEV2y9rFGKOM8TtFUaxRFOV4PduFl5ONQeuDSCRy5ICOQ9KOTQ7PL08TXe7sd0WtYuKMDEl63xsNXFOdHeQRIJG2VFSjwNhRww+QNFkxwEQysYkxRqWavTSCosTrYxA9wBOLdTfmqZ7qgxfXrqqq/qq5ufl03nRLiUTiSsbYN4Ka34PODkmSDuOdq7GxcYKiKGTG6uvn/0tJkk438+nX7du6xqVLl24SBMGrdDqvaNz6kUn5yKamph0DEpC8tJUeIOAQRYEXnQWYSokzyuGlMxz2/mIgYu7U8ta27GCid7HFa0aFdO1o5ZaUu1MqaF757oYzIOnCaljWcALKSFka+vpQMh5XdtKkSQeUmuonkUjMY4xt5XjNSunykiRJTtkHHOkmk8kFqqpuKWVir7GMsX80Nzf71njpvkRRlJ6qsl7zBPR7yZka7PgoIXsD97IYY5Obm3OlTQYUIPFqRO7HdU4OjkDEmX2Baw5PMApeM3Ljiw/I8yHIE9xIWzJvrRCQeF80upT+plsdH15CPvu1SJJ0k88xjt11ryvyICtH+7YkSY51jrwmTCaTM1VVpbs7btOgF03jd4Z4f3MJ+Qjjt8WPgm4gb0G/ZRqcWKRaRZROySlTQ1kAiZiJx+OkJW3ilZ2Pfp01NTUHmL31+hWQ+A7Q3uV5aRY9QJSvkPQS4HRcCB6MzGvwuKsq4S7Lj1ddz4vnsnsMTQkUPWjWC4zoQyCCsrD/MDXZ2chSLwNBWsZnfLyoxXT9zt69e6+2Bm0WQ8g6hi6na2pqHuOJdeKc732swo+lV6TdMg9wkdq2bZv4zDPPkPnuMq4BHp0Q8T1FUU5bs2ZNyVkfdAeF36uqSvcppbRfp9PpUxOJBGXScAKkX0mSdJp5klJNdmZanHFa3GtExDXV1dUJq5dmv9RD8gtEXABh/o53OfO9DWYcDhIOoJFvoiOue4Ne+Ux15XOssFsVD8BrO4zSApEHHse9EouALOw/9DM1cL95esfFixePrqqq+hRjjC7uXeNdfNDeLQjCTfv27Xtk06ZNdFiVtenaErkhu8XbOPJAh70gCNd3dnb+YP369YFkDjcmo4StsizfrzssFCMHKpnwuaampid477J4JiFvw3379h1PZbpdEqM6kZIFQbhx9erV/494cqtZRQ4Fzc3N51pA5HhZlv/swqejU4PdGHLa6OjooJCDVpdS6l5ieToSiVxmzcRhDCq723cx4GMwx3tg5iVFNaOXKR1QOYEoHzCtZrpeG6HXerxk5TTea1xJYKQ/DC21kJv3neGmR4GxWDUsMjV4vXkOL3Ukm81OVBTlOMZYLWPsfJ9eVU8wgW0VQfxF0+qmf3vFsxTDo+uYnOMGZRL/PLkuu6WZ0em8i4jfFAShtaqqaoedC3aQPCaTycMZYxeSbAHgSA/aBEIPKoqy8YgjjvgTTwG5YnmloGNZlg/t7u6u1auuurlUUyjAqoqKikfvuuuuncacblnmGWOPNjc3X2jmjzw/Ozo6DhNFUQs6VRRFZIxVIWIlIkYURXmvubnZsXqr01qXLl06UhRFKs9BcWFUUt0rMPt5RFwry/LTXtVzyxYY631IOj9ar4M7BwA2vczedD7uivIBxZ4vfucFGp9fF5xrPWUz1RWujocfqxS09dNACqB1uzsTQEEYEQIS78mVO+ApYJRS0oyhA4MxRvFHjDHWzRjrFARhLyLumj59+n/LeWjysmzu19DQQNoe/XMgIlKgLrk8k7b2liAIrzStbnq5z0FTZ1A3Mx2sKMo4URS1g5h4Y4x9IIri61VVVS+Vmiy2GJnp3pjHqKo6HREpawHdMxFw76qoqNgZiUT+axdw7FaSngC/qakpVhQ/JQyi+Ktp06ZNE0WR5DxRFMVqRVE6EPHtSCTylizL/zSq6/JMExgglQJAZkZ5D8sgAclrTq+15cabNSN7ncnpgfDRdwFwVzDjd2Kwm8HqaKLJXXaWGAsBiee9C/uEEvAtATdAQsQF6XTasS6T78n6aQAetj26Ru3qvpXymJmPGU3B4IgBKpVvLzCwPyRNowqYzo3gMdGVqhn1jreCET8HfJqXvZT5nk+JgGS3B0hLcnBwCAGp1DciHB9KoFACqVRqfHt7u2NNqMrKyiNXrlxJJSEGdcNpDy5ch53yLX25Cr8g5KgNOTDNA0Y8PHgd+ANbMyqEW541m0Xa42VnI2cnTYkJ5NQQetn15fsUzjXwJJBKpUbv69x3ksCET6TT6SWlchiPx5uoeK4DnU5JkniyQ5TKRtnHk5fdBtYp31yumfweglY+XMHI5z0Rj0ak9eHQDAvByHyBVbynnrF+L7l581iaZsQjB5XkZBT40xlHRBlDQCrX6xTSHeASoMzhiNigquoy4zJZluUT1q1bV0p5b9QdGpxW/29JksjJYNA3nP7gwruhU14U9Eq8DlS3+VzzztHAfG/qwMxzPIdwL6iZzXQDDYxK144oHDa/pqj9E7OCUghIQb9JIb3BIIFUKjVl3759TzpUm321pqZmerEOFMuWLTtXluUfO8lBVdX71qxZ01PyfTDIy4lHLkAqBVz8CEcDIuNsNw+0dajzz5XbCG+NI8dQLw0ro/k6k9O6eeYpnc/StCM3U13+Y9HXTPdJulaJEVHGmq5hl1zVzz4P+w4tCaRSqbHt7e2UVNaxCYLwy6amprxcczxSWJxaPLqyvZJqVDkeKTU1NZNSqZRjnSueeQZKHw2QWBk0JN4Fet4PmXPP+ci0YMzPC1teQFF4xPsLetXArATX7p71+PCoywdQ3ifizWeObqFkKXA2BCR+OYc9h44EliQbLoqo+KDHiv43duzY45PJ5Ls8K9dTI1FORMfM5lRLqLm5mTKrD4mm3SGpZbxDspOSWRMSUYRjD5gKY6pHAZl/jBqlCAgC0j8CCHpcD5mRVKb29MvpKHo//b/0/xMNopXrP1Bo0q7S14PEpYlPWpN+xBPM9a4dgVZPjXpoa9LXY+hnZpr7ujvgx2/+BSpYLg6KF4zNz4jXVOfoOCKgjNWhhjQkTodwEdwS0KsHU0CrVx0pylj8oCRJVN/KtjXc1nAEduP39MwOrmU2EPH4dDr9F25GB3hHzcsOyuRlx2OCqxYi0DTrSjhj8rG5A9TQAPRDm6pq0wFtfJXn4jN7TUSg9cv1MZfg1jILGN/xQ4EmY6AwtaCKhrZ2DbgRXn7nNTj76Sao1F2y/QKSX1Od7d4WBBmrO0OT3QB/8UP2gpdAMpkco6oq1UPiad0A8D8AeA8A/kPpmBBxImNsNABQUUaeOkKbJUmq45lssPTB6dsXrmFd8q1BMdzz5Wy+8zcTz7//hxFCBJpPuBI+ftBHgmJhyNHxMvXRggmUdux9Dc76+SqooDihIqTAM48nZUFQQK4IMzUUIf9wyOCXQCKR+CRjjIrulbtRRVeqdzWkKjNrgKR2Zb0ByQlgrGK3v+vP9bIpkkeAJJ1wJZwZApLtBuYBiSAAqUeb9XiNQkAq9zkT0h/UEmCASxuX3iWoQmO51kFJahFxJhW0K9cc/UUXD92+cA3wAJIbh1awsvs8t3VOABghiNB8wlUhINnIlxeMrIAU4SgTYZ2O5+7IE4yIaKgh9de7HM47gCSQTCZXqapaDlAib75TJEkqV42qfpUiHrTtxrWRbtU9ktgKMPm5Q+0XYNWGbCq1ElnSkNbNuhrOmFJqyZB+lWPgk/sBox5Aeuc1OOvpVeAXkAK5OzIkEAJS4HshJDg4JdDQ0DAfETcCwMiAVvCXcePGnZJIJIaUmc4sGzx464L1QlZZXLTA7OKGiJgOYm5f1dSlWozA+lnXwmmTjy2ahaE20C8YGYD0sukOiVcmPJpR7nF630ppWyF0auAVfdhvGEiAyk7s27fvJ4h4agnVY/cKgnBnU1MT1dIa0g2nbl9wt9ip+M/U4KAl8RxcZokSIN09ez6cPIlKrIRNO/w5UhdZJUVODX4BiUcz4gv3zXETAlK4f0MJOEiAAcYT8SQAfEn3oHOq/GoQIPfwtwVBaGhqavr6cJGrBkhCPwbGVosVcPfs61wBqVKsgIiQ7wXZe1AaTuH2j4y3X69Sl1P5ZEWGrCo77gNys66KVPa4pDt15J2f+qmM6mg5r4eAqlMmb9HClvOy2wln/ny15mXn1fJc7B3fIW86xtCea8RQQ/ISffh7KAGg0vZdXV1zFEX5MCIejoidjLE3BUH47bRp08paLHAgi79fAYkOsRoPQKLA2RV/egCkl35I9qAeWeYUtNzFlNuxydvPoKbRVGVomXsDXD7jVEd42Nu9D6Z/N+qpzfDOz9PvlAlHwY/O/TJklWzBntI0JP0OyQuQeDSjHECHgDSQX96Qt1ACQ00C/QJIPcccA6iJuJvsCJBWP7cNNu54Eg4QqOCjf5NW/rFq5xKYX2acNJHUR78Il04/xRGQ9mU7Yfoj9TAm4p71nedI5zHRUYaKk8fMgG+fk3QEJIpDOlOPQ3LbqDzzFQNGGqiHGtJQOyPC9YQS6DMJaE4N2C0X79TAyardwUxf6gRIbk4NBEirnt0GG//9JIwWKj01Eis7vfOaObDxQddT+RiAt2LmZXDJtI+5AtK0R+phrAsgBQVGxBMB0tzRh8L2c5cXrSGVUzMy5B4CEucLEXYLJRBKoNDSQ27fYpdScgEpnsO3ACxYzsvOze1bFES4609bYdOOn8EBgtc9YO8MzlqR2S0w92erNkAaxOoTroQvHHqi45YhDckJkHhlwaOp5BjI5bD76P4Hwfc+5WyyMzI1OLl9887Hqx3ZrRNDt+/wmAklEEqgSAngQVsXrBG7vVMH8R6yfvigL/ZqUYQ1J1ztGBhrANLGHT+D0RyA5Mc8ZwdGhoa0ZvY1cMHBs8sCSLzAYIBRTkNicOx+k+AH593parKj1EFWQOLVjHLQx/+kQ0Dys9vDvqEEQgl4SUADJIEDkLwIFfN7kIBkD0TElZ15Lvf3TocvAcba2dfCZw6e5RuQeI5zfkDqpUaA9OGRE+Hx81eUDZBKBSNNqqGGVMyrEI4JJRBKgM6P/gUkBiPIZHfC1Y7JVd00pMLD3/o35ppFue//3n87P38CDGnW1fDZQ+b4AqTgwKiQEgHS8ftNhkfPu6MIQPLmzA8YuckwBKTwXAklEEqgWAngwdsXlK38hB1TVu2gigJjZ10Lp085znYNTndI3qa5Qu2I99AlHu864Qq4WLtDMkcA97JovkPyPu514xt3wGshRZmpMOeAQ+DhT9zuy8suyEwMxupd3exDL7ti38VwXCiBYS8BnLqtdgN2ZW8upyScTVQMqsVK2Dj7Ojhl8oftAYm87J7bBne/TG7fdk4NZjduO5duf4XqcnWUAO786KXwxekne3rZebl99xziXGBkf9TT31ItJHL73npOo7OXnSV1EO/dES9Q82iXoZddOd+kkHYogaEtAS0OCYvI1MB/D+IuQMrUsGmOc+ogIw6JAGlUDyA5gVC+a7efg1Y7bHXQICqpj8yDy1wCY404pNFecUhcQGR/1JtXQ4B02tjD4YGzE1waUl9rRoYtFMWwQN/QPjLC1YUSKJ8EcMrWG+4Wu1XbXHZBgY4z+zkNiQ+QfmoCJMOMZnXh1k1jPuRlp0UQ1S9/ZJ5rpgYeQOKXn7NmZCyFAOn0sYfDtzwA6eNPrYQK1abwlI1M/AC2p1lSfxShhuRj84VdQwmEEsiTgAZIQlcRyVUDESQ/IK2i1EGCNXUQnznODF9ebBtHeevMqzw1pKkP1QKrqPIi6YLHDECl/HXejTLcfWLckfCQS2AsxSHlAMmbnh8w8jTVmb4LQkDyln3YI5RAKAF7CeBB37lxA3bLZb1DMqa2fmXToThSrIS7Z18LpzqUn6Acba++vxt2d7yjxeKQ1kHmqJzDHKPa3do9DyU71f6HZHrLxdNo/bW+xuc7gKD1yfWnZksTEKaNngzjq0Zpfe0aZU545s0Xc7QcaGqz95jscrzl+BRMfKo6D73HPtHMrSVHW+MTGFQKETh23Axbd3WjhPmZP1sBEWbPc+9z8NR3tK58vSzSEQVZGNE5Zve87R+EL10ogVACoQT8SAAP2nrjOuySb/EziLev+4GW+0anO6QNs67xLNCXlwPb7ry1m4y3Hy3I0pfH3NYDVjoAFpzgvPPz9nMJXO0pP9GXgGTxIdEcQkSUI9XdISDxviRhv1ACoQR6JIAHbb1hDXYpt/qRib8vZ8OeUzjKACSKQzrzoI/4YWHA9OUBrr5gVtOQ3nkNznxqJUQcHpAfMx3XMzZf4elOIUxERZSrxuy5/t4hW9WyL55nOEcogeEoAQ2QwCcg5QRldbHuNQgVCtKuml8uU8IIsQLWnXAVnHXQRwel/AcUIFG275+VDkjFgpG2K0JAGpT7OGQ6lMBAkIBPQOI5qqz2p3xX7N5F95rs1g5CQBooQGTIs/cOyR6QAtWObDSjns+REJAGwnsd8hBKYFBKgJwa1kJ3toRs304X6M5AZNal6A5p/ayr4eNTBpfJbiACklbC3OYOKVAwsmxzqxxCDWlQngMh06EEBoQENKcG6Mr6cGpw8+By0qAcKrtq9ZCohPm1cNpk+9RBA0JKOhMDDYTMsukpYa6Z7HqfUeBgZNKO7OQROjUMpB0b8hJKYHBJQItDwqLjkKwAVAhWbgci/bafWAUb51wHp0yyTx00UMRpd/jyhJ/6jYEy3875Wbud23c5wUjj0y4LhSjIYnVX6GXn5+GV2Le1tfUSQRAmAIAIAAJjTBAEYUttbW17iaTD4aEE+lQCnIDk52jj598ApE1zroOTHQCJ4nZ++sqf4Nk3XwIBewNjnVwq7Gbn7Wv0o1DVsw+ZCTPHHea4mHa5C9Y89yCMFCKuC+ad2wxEdjooub2Pqz4A5n/4PFDUwshXKyD5eWI8N4OaD4vOmKumGAIS/wsQUM9MJvNXAMj7oquurj5w/vz5uwOaIiQTSqBPJKABEnTJtqmD+oIDCox1AyQjl136pSegQqAPwL5pa2deAZdOP6UnMNU667vZdpj+cLS0TA0+loKMwSfHHAEPnrvMPZfdz1aAyIUwvZN7dreJN3JkPQQkW9Fs2bKlpqKiYuR+++339rx58/jSc3DujxCQOAUVdhvwEhgQgORmsjMAacPLP4X90V0bsUrb86C1eTxaJgjGYOXMy1yzfZOGNPW7URjvkly1mPkL1qCbxShTw6ljDoNvn5N0z/btE5A8eXTxqLPd3cMckDLbMvvBblgHAJcBAKWnp39It7RzPyVgkgHgXUEQ2lRVXRuLxXxnuAgBacCfsyGDnBKgAn3rWVf3Ys7+AXdjUKOnDnJyaiBAWvXsNrh7Bz8geR6yDkBk/DUB0upZVA/pJMfyEwRIB303ChMcAKkYHsxsWZO+EiCdNHoabPfIZUepg3g1JE8e/WhGBvPDFJDa2trOUlV1GwCM1u9yinlXSOIESH9FxIXRaPR5HiIhIPFIKewzGCSguX2zkty++ZaZf/+dO+no3yOECGycc62j27dRoO/uHU/CKAcNyfNgdWHR7j6EAKl59tXwuUPmOpTnA3ACpFJ4yQekfEoESLNGTYVHPvnlQEx2nnz61Yx05snLTpSrxg6XTA1f+9rX9u/s7HwMAE4pAYjsdihDxCXRaHSD1xsWApKXhMLfB4sEtMBY1iX7Sh3ktjg/rtEGIG2YfY1jpgY3QPI8VH0CkVlD2jD3Ovj01Fm+AKkUfoy5nYrqESBRCfMfnHenByCtBNGjBpNfPn0902EUGLtu3bqxlZWVzyLiIWV44dVIJDK9trb2f160Q0DyktDA/n3Tpk1HV1VVjSAu9+3b959bbrll78DmuHzc+QYk73pz/o67KiECfgHJ3wyFwvM6YElDunvufDh/6gncgFQqT4bGmMtMXtgIkI4bOQkeP3+Fxx2SOyBx8cnrUWfD57AJjGWAmdYMgcVUp9cTEf8MAGR2e4UxRrn9yD1yFADsj4hTGWOHA8CRZCiwofHDWCx2Ps+rHwISj5QGbp9MJkP7wrhjvCgWiz08cLktL2c4aev8Ndip3lpksYGSuDM0pLtnXwNnOuSyM2tIfp0aI1at7gAAIABJREFUrMx5AZFZQ1o351q44ODZXIDEdch7SMqr3DgB0kf3mwKPnneHs4akJ1d10pC4+CzSVNej4Q0TDamlpWULIi5weKxPC4IQr6ur+73XC5JiKWHi5omfVVX1EgD4GABMozGIeFU0Gv2m13j6PQQkHikNzD6pVEqYMGFCluLHdA6HOSB9Z/5a7FKX9Acg0QPI3SFd51h+olRA4gUh83YlDSk96yr4wqEnegKSm5cd7yvAU26c+swZdQg8/Mnbi7pD8gtGxchN0/KGQfmJVCoVmTBhQqfNnRGJ+dZYLLae99lb++nOETT+k7FY7A0eOiEg8UhpYPbZvHnzZYqiPNDzMayqF990000PDUxuy88VTtw6f73QqS7uD0Cit7dGqICWufMdC/RpXnbPbYOi3L697Yu2EiZAuuuEy2HetI95etmVCkhemlHPRgUGJ4+eDltd4pBe3rsTzvoZmex6l8UFRBqS5DsmFw9IghwZ4pkaWltbFzPG7EDnS7FYbEX5X9v8GUJA6muJBzdfJpP5DwAcalBExHnRaHR7cDMMLko4eev8u6FTXdRXgGQ9IGvECsjMvd4xdZARh7TeIw6p2AM0/3HluCNAWjHzMi0wNq8woKmzEYc0ziUOyW0r6LVsATkRQwYVzhh7BDxwdsKXhsRFPigwIlQTxSEPSJlMhrSjvNr1jLHf19fXn9gfr38ISP0h9WDmzGQyFIvWm4IG4NJYLLY1GOqDj0qfAZLTwThSBySn1EFugGSAEAFI6a2XBoHFipmXu2ZqMABprGh3H+3NjVaG3UcjI/PZYw+Hb7kC0k6tHhJpSNzUAwKjnJI1bADJeohQXr/l9fX1q3w80sC6hoAUmCj7lNC99947oaOjY5dl0hCQ/GhI3Acd56MlQGrx0JBan/sefOO/v4AKm1x2NA1v/nG3fobVymB7yYcvhM9Mdw+MPenxRhgnVDnOb5UVL59Oazpu7KGQOS0GslKYecZcwpwbkAICo7y8ecNDQyoAJEEQLq6rq+sX238ISJyHzQDr1tra+iBj7KIQkHolgJO/c90G6GI3+0nGGeRz1e6QTpwPp0461pEsOTZEBFHLLm38z6wC0GGs5WZBI0ML0/taMlIjgZf+P61v7nc7mipTbZOYGkzSXMSTBh7a/KjP70zTL585QENNn1e0lEYKqDaJVQ0eciXMV4DA89UQEBj1aEaGYIYHIJnddI2VXxiLxR4N8t3gpeUHkPSv8iYAOFPPKkHbqydxPSK+IAjCvYj4YG1t7bu8PBTbL5PJzCFHQQAgF3gyg1aaTFjdiPhbVVWX1dfX/6bYObjHMcC2zW0xVVVTunu+8eVH6Z3ISKEg4j2yLKcXLVr0HjddS8e2trYDVVX9IQDMtH5PM8YyiPgM3RwIgqAwvRkkKI27ntH9sWg0+g4vD62trecxxmoB4HTdGYeeudlUqB0ziPh/ALB1165d30ilUrTuPm04cev164RO5Zb+AqRqGy+7YO6D+lSO/T6ZOdu3KyCVC4h6AImcGrqHdPmJTCZTAPmiKC5auHDhpv7YCHaAFIlERpsBpbW1VWKMkZv6fpwZJegwfk0QhKV1dXWUEimwtnHjxqrKysqvyrJ8PiKO5SRMwaL3RKPRJCLvzSsf5S1bthwiy/KTADCdUzb0QbKbMVZXX1//Xb5ZAFpaWi5FRAkApnDO40g6Eol8qLa29h9uc2/YsGFiRUXF43om+Lw7Tw6eaY/vYow9OWbMmPorrriCG/w4aDt26YlD6i9AGiGIsJ4yNUz5aCnrGPZjzSXMBac7NQsYkdBKAX/bPSMKiihXjRnKqYPsAIkxdl99ff38/tiIdoC0+5jdFakzU/LXvva1KZ2dnT8FgA8VyRvtmsdisdiFRY7PG5bJZK4FgDsB4OAi6f2LMXZOfX39f4scb+XnGwBwhYfl32kqAqY/IeInvLSV1tbW9YyxwHKGMsaOqq+vf8mJsZaWlhbKh1gq8On0mSiKxy5cuPBvQcjcjUafAlJBuWsGUCVSxdir4OyDSHsNW7ES0ABJD4y1BaRya0YG48MDkOggOMLyrF6LRWNTAfn9SYp91tZxdoAUi8Uwk8mQGYwOEco4Xmr7TSwWO7kUIq2trcsYYyuLPPzNU7czxk6rr6//U7H8MMawtbWVchByZcPwmOeVSCRyqluap0wmsxkAyGQWSBNF8ciFCxf+045Ya2trC2MsFshEOhHaT0HSc6JVNkDi+fKmM7JKCAEpiAftqiEFCEbEq6s2PQwAafPmzdcrivJVm+e2MRaL3RzE8/RDw8FkVynLMt0BVVto0d89zxj7lyAIr+ump/EAMBkATgCA4y13Cz3DBUG4ua6ubqMf3oy+mUyG7mW+bDeWMUYpmH6FiC8h4tsEoIyxqYh4DGNsNgCMsxmXZYwd66YlOPGpZ0cg1+qLbfrQrc3fEfFZAHiRzFaISDI8lDF2KgAQPwWNMfZ2RUXFpNraWrprKmitra0EEJ9SVVVFRPqH7oc+CwDWmjrPIOIbxISeaorudXpMxIwxkSoCi6IYraur22mdKJPJ0N3gz+xYBACKefojALyAiLtVVX1PEIRxqqoeSLJGxGmMMUpllbdnEHF7NBqdV8xz9zsGJ31n/lroUpb4HcgDOF40ScojhArYOOdqODM02XmJy/X3nIa0E858amW+U4OxlXmqvXJw4GnaHQaARGKyiR+hv6aDhlL+9ETec4i05C52gETOCYwxcxXZHYi4MloX/bqbFrd58+bZiqJ83VqB1mCymC/ltra2z6iq+n0bzWgfAKyOxWJ3OQnhvvvuG9HR0XEfY+xSmz7Pd3V1nbRkyZIOP0Jsa2urV1XV7r6PDupYNBp92oleJpMhLZGeb08wq6nvT2Kx2Cd4eclkMrT+GnN/tcRMDXbmZD2X4k319fXf8+Jt27Zt1W+99dYXVFW9BgDoHmWCoigjFi1a1OU1NojfceK3rlkHWXZLEMT80qCzsprcvudcC6dPpg+zsBUrAVunhr7UjAzGxaHv1KADEl0Wn+fwvCgHXV0xxfaKef52gGShc380Gr3WjzNAa2vrt+1AgDF2QX19PZm6uNq2bdsqd+/eTRrQRMuAd0ePHj2d97K8tbX1OsbYvTaTro/FYtwf1C0tLUciImk+eQ0Rv79r166LeD3LMpkMmQsL7hkYY7N4TYl2gAQAl8RisQe5hGvptGXLlvGyLFvL1r8RiUSOLsZjksyamzdv/mJdXd13iuGnmDE48VvX3Q1ZpV9KmNN5SQX6MnOvc3X7NhbW66Ldexmvffj3uF3n3Lo1N24tOJT+1ftN3+N2beuinU9TEETX+CaaVlYV3eVbdycvcCUPnk/BFItlfuAFgNQfYEQMDQO3b0PumUzmTQA40OHFoyfw2Ugk8oSTGaeYF9ZujBsgIeJXo9HojX7n0s1adEcxwzJ2VywWs4KLI/lMJkPaBrkam1vH/vvvP+Hqq68mDYG7ZTIZSqljNbNlI5HIBK4DN5ehnZwhrA4Vz0aj0Vl+AJuYzmQy/zaS4ZoW8UEsFtufZ1EOgFR0YGxra2uCMUYu/T0NEc+NRqPk1DIo2oAApNa5851TBwkCfPWFx+ErO34OKPorYV7KE1h21KfhfI/A2HMevw2w0q83ZfFczT5gKmROdQ6M3bH3NaCKsWa372BMqzyBTfq6hhEgfetb3xqzd+9eOpQOcHuqiLhaFMUvlwuYXACJTZgwYcS8efO6i9l1LS0t8xCxII2NHxNOJpMhc5o1nUnRh24mk6G15DlpIGJbNBqNeq2xra3t86qqFpR22L17dwWvZmSeI5PJkHnuR9Z5J0yYUMUj86ABqaWl5XuImOcNyeMe7iW3vvx9UABS03MPwvp//gj2E/KdhXwck75kSkGxXKmDHqqFsRUjuWh73r04UDHWqACDM8ce4ZE6KHhA8s33MAIkemSpVKpywoQJZALSykZ4tHcFQVgYtAnECZBEUbxm4cKF93sx5fR7W1vbQaqqvmr9XVGUA3gCQ1tbW+9ijC2zjP9jLBazdQzg4TOTyZCb9pWWvv+NxWKe8m9paXkSEc8yj0XEW6PR6Dqeue36OJjutsVisS960QwakOwyP0QikZNqa2t/58XLQPm9DwDJGTbIrFYTqXI12UWECKx+bpsGSCMtgFQuIZJWsXLm5fDF6Se7J1d9aAGMraA4Q/fm+1DXyZklR4B0xpjD4dvnJD2Tq5KGVKpmVCzPw8lkZ37qra2tNzHG/Hig/b2iouKSBQsWvOC1f7x+dwKk3bt3i6lUimJlim6ZTOY13QOvh4Y16NaJeEtLSxciUuYFc1sQi8W+UixDX/nKVyZ2d3fbleWY7FauQ3fW+INlXhaNRkW/pjrLc29kjFlzGHLRDRqQNm/efLOiKNaS99+MxWJXFSvvvh6HEx+4dj10U/mJUpt/fSXn1FAJLXOug9MnH2fLAAHSqme3wfp/FWpIpXLsNJ4O89UnXAkXT3PPZXfQQwtgnAsgFXuo20mSAOmU0dNh+7nLPQr0rQBU/T8LqyyK5X24AhLJ7/777x/5/vvv3w0A1/vYm68j4hei0ehvfYzJ6+oESMV4xFl5aG1t/RVj7BTL37se/kZfSyVU+mtyiR5bqrOHgxmwMRaL5d2fmHluaWlp0LMkmP+6PRaL8Zk4HB7Opk2bPikIwhPWn3nMgHaAVEr5iZaWlnGIuMcKuoIgfLmurq7Py6IUs59x0gPXrmXd/VOgL+f2XQkb51wDZ075iCMg3fXsVtjwrx8XmOyKWbDXGC0LN2OwZvY18LlDPAr0OQBS0Ye5zpwTIM0ddQg88skvuWtIT64ALCH7eam8wzDxsnPbR21tbWQ+WqSqqh/v1ecOOOCAM6688krfOdIc3L5/G41GqQJtSS2TyVBqnM+ZiQiCcFxdXd1f3Qi3trYezxijEu7mVpK5zgR07TbxVa4l3+3MWYj4tWg0ekMpAtq4ceNHRFF8zkpjwoQJkXnz5hVmQTZ17EO3b0b58SoqKi648cYbyRFnwDac9MB1a1i30uclzI1Dt4oAafZVcJZDpgbSkMoJSL1ndy8M0KG8Ye718Jmps9wrxpoAqeSDXK+R57RTSEOaud8U+MF5d7prSD/rX0BigqBElKGdOoj3baYvVkEQPg8AtzDGjuEY9wEiNkSjUYrq5252gCQIQqKuro7yppXUMpkM5bGj8uo9rbKy8pgbb7zx726E9dQ1edkCEPE70Wj0spIYynm3FdSjAoC/x2IxRxlnMhnKWJGXPgkRPx+NRh8phZ/W1tYZjLGXrTR2R3eLKXQ3lzqY7EoqYd7W1jZXVVWnOyPSUB9DxFQ0Gn2+lHWXa2yfAJKbAYkAyS11UDkByalIHv39xrk3wPlTT+ACpHKDET18AqSPjpwMj5+/oiwaUiBroActohJRRgzpXHbFvIyZTIai/CmW5nNeCUUFQWh88803Jd77HwcN6bPRaJSCUUtqdoA0YsSIo6+//vqCWB7zRC0tLRRkagUIciOnDAhaw1x6/p6mZyco4NemH5VsMGeqpjGujg2ZTIYyQIyxEH8cETXXc6e5OfikrAYXWJmurq4+ZP78+a+4Cb8cgETz6Yl0Gzwe/E8oWe3u3bsf5t1nJW0kzsFlASTeGwzSTkaIpCFdDWcdZJ9cNWhAyrdm2XNKh/P6OfPhgoNnewISr5ed3fPglZMBSCfsdxA8dt4dLhpSrkBfMSa7UgGpR64hILm+ehs3bhwViURuZYxd7eaZxxi7sb6+3i49UQF9O0BijJ1UX19fsneVXeyPKIof9kq0mclkPgCAku5nOM8wrRulH6qvr7fLnqD9bucu7oe+376VlZWzb7zxRkrT49jKBUg6KC1hjDU7pYEyMbUXEe9gjD0Ui8VcAdSvDIrp33OHVOqBVMzkdF0zIlIJm2ZfAx/vgzskuh/iSVxPsmiefQ18nuMOqS8B6aRRh8LDn7w9UA0piOeeB/IiyhU12SFdfqKovW4ZlEqlIuPHj78TEZc6JD8l77hjY7GYq2lMP2zpPsecJoj++pAgDphMJkNFB79gZr+ysvIjN954o6vJxyGFTRCis6WBiC9Ho1FKJmsH2OQK+37ZJrchXFFRMXfBggVWr768nuW4QzJPoLvtk8MFmSpzxdtcGiL+SFXVRQceeODLXvdfXrSK/b3Hyy6Ig6kYJqpFcvu+Fk6b5OJlp7t9W+OQeObLHZZ+dJFchgfysrtk2sdc3b7Jy84vIPnjRF8ho8pZDE4bPQO2nrtsQAFSgf+EKMgVNUO7HhLPvuPto7sx0x2EnTbxcCwWs1YUtTtwCwCpurr6wPnz51vTyPCy1dMvk8nQHQslAe1pkUhkVm1trWum7b4GJMbY3+rr662grPG8efPmIxRFcSzV4FsoHAN44n+C9rJzYoucbFRVpbtAMkPxZH6nEh+fLiZxLYdo3EHRSB3UX4BUI1aBW6YGv3FIxr2QsWoejcgqIaJBcUiXTj/FMw5pDGdgrH9Y1HFUt7LTHdLHxx4BD5ydCASQgnjets58ISD5fie3bNlSIcsyXdRb70WAJ+bHT8VYv8xlMhm6h8q7I+H8+i/49tKrkf6J7mv0jNdaPVTTHZGQS4adu1ui3wRByzuixVIZfWkI/WS5W9oZjUbTdutzCPAl2hvcaJbCJ1kJo9HoDjd5Bx2H5PVsSW5btmyp02OVKO2Na0kJel7jx48/oy+1pZ7A2CAOKC+BFPyuB8byANLal56AGsE5dZAaYLUOLQ5p5hUaIAkOz6xd7oKpDy2A/SvykvX6FgHvgCww+MTYI90zNVC2b83LzplqUM/Z0bM8BCTeR5rXr7W19XOMsYLqo3pmhy0eB1vZNKTW1tZHGWOfMc8vCMKJdXV1v/fgyW4XrojFYl8qSkAlDCLz6IQJEwrKQkQikcpypXPiYbevAcnMEyW9feuttx5XVfVsD16zsVjMGtzMs7yi+vQvIGnJVd01JFEQYOuLT8FPXum9H8ztdPN+p5SqhY23Xy+1XppXHf0JOHXKsa4a0tU/XwNjhWrHzwxj/t48p+58GrPn1lLY97D9p0LjiZeCohYG3/ckV33yTkdAKjsYEdshIBX1ItKgTCZTEF+DiI9Fo9ECLy7zJANUQyLtgEqCm9uWWCxGVUz7vGUyGaoDNcoCrCfU1dX1eP31NVP9CUjGWimJ7vjx429FRMo24fTF/340Gj2glIwWvLKlO6QN0K3eHNRhxTux0Y/ukFo9sn0TKAkoaulw6NC28tpzgGN+tm+7UnJ0zFN/w+PUiSaNVW0OfoNvLXO4nnmbl2YQfCqqbCviXkCyj0MK6vl6xtyGgOT3Fejpb3doUuG6WCx2mhvRcgKSXcJOHg+ytra2J1VVzcsbBwBPxmKxc4oWUAkD29raXlFVdaqZBCLGo9EoeaL1S7MDJMbYF+vr6+m+p08bmY1VVb1VVdXVdhMLgnBBXV0dd9mRYpnvqYcU1IHllxFy+6Z6SGeE9ZD8ii6vvxMgBflcPcGIOAq97Ip+ji0tLf9FxEMsBJ6NxWJUydWxlROQMpkMZcem4N6eJoriRxcuXGjNwpDHX2tr6yWMMevBui8Wje3fT2Xe7epX7YzFYnkgVfTDK2Jg0PWQimChYIjuAELP1lppuCMajY4st5bUE4cU5MHlJRjzwVYlVsCmOdfAWWHFWC+xuf5OgPTy3tfgLFPqoKCeKRcQGdyFcUhFP8dMJkNJQ621hn4Xi8VO6kdAKqhBVFFRcaxXUlinextBEM6uq6uzK7FdtNx4BmYymTsB4HZr3yDy/fHMb9ennHFIxfJE49ra2k5RVfVXVho8+flKmZfG9hkgmb3fzJfulSLFIV0NZzukDip1gcNlvFVD6hcwImGHgFT0lrNJRkq0Ho3FYnk1bqwTlFlDKkgdxFtjx871m+dOrGgBugzMZDJnAkABEPIE+ZaDH6I5EDUk4mvbtm3inj17XmKM5RVnjEaj5NlYVOQKrwz7DJCcglJDQOJ9VO79rBpSCEjByLXPqOSqmVIyzjz/HES8PRqNruxHDakUQPo1AFgTvL4fiURm1NbWWrNSl1XUums9pTvKc7SgcubRaPTosk7uQDyTyfwHAPKySyDiomg0uqk/+DHPmclkHgCAvLyDQZQz8VoXHviNa9eioi6xxu/QQPq78uIhQJV2h0TZvu1TB3ktIPw9JwGzhgSspBI4Gj1fZjrzQwg1pKK2ZFtb20pVVZdbBstdXV0TlyxZQnnYHFs5NSS7LNk82b6J2ba2tgNVVbXLLv3rWCxmLWlRlNz8DHKqWSWK4skLFy78jR9aQfRtbW39OWPsDDMtxtim+vr6RUHQL4VGJpMhbZK0yp7WF27yeOA3rlkHikrZiEvhv+ixVZEqaJtzLZweOjUULUMDkF5+5zU462croJ8BaUinDrrvvvtGXHfddRTEGljL3Js5GDrgfzYEfxmLxU73mqicgGRXfqKiomLmggULCkouWPlMsZQwoXUCaQEHW38TBOHmuro6PwUNvcTg+ft99903ur29ne7pqqyds9nspMWLF/dpaYa2tra0qqpxCy/P7969e2Z/Jjz92te+tn9nZ2dBGZQ+AaQJ37h2AyrKzf0FSNWRKtg89wY4dfKxOXduUzAOBaWSa7WgJwVWye2bqZCrWaQ/Rt3VmzSEXH/U3MOpT86le3jQjAgCvPzOq3DaT+8AcHFX93prS/4uGeJu31SwDhH/JghCw+uvv/5+qQdHa2vrUYyxf9g9l0gkclptbW3B5bK1bzkByc7tWxTFOQsXLnzGay/R71/96lfHdnV1EQgUpKxBxMz48eNvLjYTAMXQTJw48RhFUVh9fb135V0GuHnL5gsVRbEtOYEj8Ojo9VHXLOZua6aPlY6Ojouj0eg3OWVzeFdXF2VAz2uiKC5auHChb7Nda2vrbRUVFV/fuXPna6Xsy0wmQyZiq7b+fCwWsy9ax7NYzj444ZvX3I2yuqi/AElAAY7YfyKMrhhpCXV1X0F+WKxzX95+RIG3L2+/vqZJ2SP+9O5/ijazlgxGtOBhAEiWCqp0T9IUi8Ye8+PO3NLScgIibgUA24SgiJiORqNJnve4nIBklzqIJ1ODme9MJkOZzf+f01rIsaC2tvbvXhfmlPrmjjvuwClTppyVzWapAqrmfYiI50ej0R/yyIr6tLW1bVBV9WaH/r/T87i9xUOPMh7s2bPnMsYYZaAgJwA1Fot5JjI1aDs4snSJonimXzNiS0vL1xHxGl0mt+zatas1lUp186yD+pAzw+7dux8FgPOsYxDxMK9USLzzuPXrd0CyYy6oC3m/AirJaNmbjiFv2nIAfdDyCQSIjFUPP0Cy22YfUDkEQRB2MMbeRESK3xinqipdnheYr2wIfCUWiy3g3b/lBKRiUwdZec9kMlTa3etuhBwdnmCMvSgIwk5E3F9V1UMYY0cgIh2STvnXzovFYgVlxJ3kp7ukk0Z1pIeM/wUAT1HiVkEQKNPDJMbYJAAgMyppC3YJYnwBUltb29OqqjqZZX8niuJ6RHyYUhxt2LDhkBEjRnxEUZQr9GKHeZqeGZAs66L4tgcEQXg4EonsuOGGG3ruJNva2maqqkrJc28FAMqKbtcCqfTLs58HBCAFfcDyLNzcpyQgspmsHCBkTBO0rAIFI2IyBCS/2y+vvyAIX6qrq6Ovf+5WTkAqNrmqHfOtra2fZowFHu3vV0Mi3kjbam1tbQOAWm5B83X0BUi6VkJFAgvutVw1CcR50WiUYsR6WiaTuQ8AruVjUzMI8WQA3bV79+7JpZgAOfnRuuGE+69Zj6q6uFyHaNAHqJ/F2fUNDHz6UCPSXiCfJTS85BQ4EBkThoDkJXqn39+Dajg2Nt9/kbQyA1JR5SecFqln3n4KAI4oVlDWcYj4mWg0+oNi6LW0tFxK2gPn4cwzBYvFYgVZ290GbmzbOFNQhN8iIncSU7vy6y0tLfci4nU8THL22RaJRK7sywS0mts3U+QlxZ53QR+UnILy3S0QIOpjEDIvMkg5lw2MiOEhnjpIv6Q/CxGbGGOH+d6IlgGISIXubhVF8eliX/xyApKd23ckEjm+trb2L6WsPXNPZg5kgb7wHau8etDfBQANiqL88Kabbtrjdf/kRqulpWWcKIo3qqqa8qupmOj+k3LjIeKv6+rqiDdf7e7Ndx8RUSJ0f3MUz0DG2AX19fV52ua6deuqa2pqzlQUhe4mncxvnuQpeJkxFucpDulJzGcHPPD+a9aoqnJr8YEnPmfso+6BAJDBa34a7rwVlEuzpEmCBKGepQQqGJuHOYzikLZs2XKIoijTGWPHIeIxjDFyUDiCMTbF+rXLGOtGxLcR8V+I+LQCyh8FJlCVU9fKqzyvS2tr6zmMsVGIKDLG6J6loqamZlsQ7uktLS0nIiJd1vd4yZGX2qJFiwrcgnl4zX95ADe1bDoWEecIgkBVaWeQ7ADgAAutfYyxFwRBeF5V1V8wxv5QX1//YikgZMfrli1baN6jFUWZCwCf1vk5iIoSmPpTkN8riPgXxhjlfPuVqqov3nTTTf/2vX7LAPIanDBhwsmIeBZjjMqRfNi0j9oRkVzo/8AE9hgo8EQsFqMy8YWNAbZtbqNihXQ/NJMqD+v/jLfxdqS7sT8zxv4PESkW6w+xWIy8IvulDSlACvysdbGyhkDksF+HESC5vbHa3QDsrma7WNWoUaM6r776aronCBuHBMh9WlGUGkVROl9//fXOvrq/cGLt/vvvH/nWW29ViKLYsWjRoi6OJZTWhWklCbTjzJj7lltu2Vsa0dzojRs3VgmCsF82m1VuWXzLu348Q4OY34vGkACksgARSc7hyq+cYETTBq0ZldVEZ91hISB5vXPh76EEQgk4SEC7Q1K1O6TAj/WyCL1sXPaTWc4QUtAg1EO3bAIrfLxaqinNqSE7Zve87fbmhLLsipBoKIFQAkNBApqXHVOVxQMVkMp+nroAkaajh1GuAAAFoklEQVSt9AFQlwOM+oDtvP1vrAFFUa6o6Q4BaSicDuEaQgn0sQS0OCQmK4v6G5DKDjy9qkjuT/1kjjM/36EERMa6QkDq4zc4nC6UwBCSQL8AUp+BjxWEhjAQadpcz7/6bocWlJMPNaS+E344UyiBISaBQACpzwHG6yF4mOH6yhRXbm2oB2/74QE4aXehhuS1OcPfQwmEEnCSAFK2b1XOOiUaHDyS4wCh3gO8b0/wcpjmBiIYaQpoqCENnncm5DSUwP9v72xC5CiiOF6vu2d6emd2s6tZRSREISiIhxzEi6CeQljEWwYRk0vADYJCggSX5NCQqKBRLwoGJH5c5yAS8eYheBIRP8CLEISAEliJZjfJZKarqqV7ZpadSZvpj+nuqu1/L8uwUFX93q/e1H9f9+tqxQiE70MSnB9XzK67m5Ngu+0iihKijM1ThAYZXvEzFscnVNkVPy84IwjsFAJh2bfg3gktHIqZBZUlQqFQpN2DKcEElCFGcX0j0xCWaCz9ffTCZgKX0BQEQAAEWPhgrBA82Hq83CPqP/4pe9EGwjN6IV+Zxu9kEYorRCP+EKQyIxHnBgG9CUCQMs4fxGgcIAQpY0ChOwhUmEAxl+xSZD+Tc1LmZbio+ChCiMLspIR7RSN/0/gIQarwagLXQSAjgexFDdMWzDivgIpwQjUBSnrpKsu8lClCWcQo6Iuihiwzj74gUG0CpZV9qyg4ZWZCW0IwTeBzjtc0WdF2k1D2nfMEYXgQ2MEEwgdjpcenves+EwJdxCdrdpAWkgoZ0awyQAhS2ihAPxAAgVCQRN/LVZB0wZw1O0jjpwpiNEu/IUhpogB9QAAEwkv+935xeLC5asWOWS7CSdGpIEK5ZYMm8focx27fSYMC7UEABBjt/uzwBzJ4/USFDohRfg/wEhGvtSBIFfo6wVUQmBkB2v3pS+9JX+qxU0MKt8sUn60spORChUlseTKBIKUIUnQBARAICdDix+0zpl07rVvhwbT5y3PRnXZuFYWoMB7Cv1kzmw9g66C4UYJ2IAACIwL06NsvHFu/z/iIETN0xlLYghsTkkr3iQKTC+FDjFk9/wrVm49DkGIGCpqBAAhsEaD5d55/qr44961vGbZuXApZZBNCqaQQbU8Jr/cuHd+z/4DbdvsJ0aE5CIBAxQnQQ+6zjWsLi99Z884TzEy5rULOEFUUnu0uqyZChWVEk/Pe4xtso3fm+hsXz+UcEhgeBEBgBxIg13WN950fj1HLftd06nMq+Ki6AKl4j2hMIAt4BUZUnPj/3Pqeef6rG2sXf1AhjmADCICAXgTClGjhk6P3+Neurtm7Fl6XtfyzJF0EJ3LRVaxiTgUhCmygf3u3uGArN05+eUmvrwCsBQEQUIXAlvrMv7XyiNGo/1xrOs4sREln0ZmcnFCDIETRMRtE0Gbfl13v83NLz728urrqqRLcsAMEQEAvAmPp0IvuK/u/bv153mjaT5Jt6uXJjK1V8b7QnUJZokoSY9STTPY8KW97r92oOxfYiU53xtOA4UAABCpE4I7rc4tnV/Yy0/xJOtYuo9UwSOti8GQzqYMIjTwqPQPteoz1eVd64sODDx9Z6xxqS0Yq55HJYgGtQQAEiicQecOocXZlr21bB3zTOEWWuYcZFPwwFvyOHaO/p/2nHrddeDdieAaMWXw43OWMPmO+kMwXQhpdsSkN9pXP+ZsH9zUvd9odoZStMAYEQEBLAv9fweAeqrda/X02p2c8Qx5hJj3IiC2HXhJF95vc7iFuO4ypPk8iQcL/w5fyV1mn806f/75+8purWkY9jAYBEFCSwNSSuqAs3H3sN+vp9eX7f7l5ZZkJa9DHkON9pTFIaUw++IzbLknbio4ZVgkIf8h9+DkKJ0lD7sPPJG0TjGlbjuc0b1/+a6nBWbuDh16V/DrDKBDQm8B/ciD/bYdiwqcAAAAASUVORK5CYII="
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "radioInstantAlert01"
    }
  }, [_vm._v("Instant Alerts"), _c('br'), _c('small', [_vm._v("(each alert in its own separate email, "), _c('br'), _vm._v("sent immediately)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "radioInstantAlert02"
    }
  }, [_vm._v("Batched Alerts"), _c('br'), _c('small', [_vm._v("(group multiple alerts into one message, "), _c('br'), _vm._v("less emails, slower)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "two wide middle aligned column"
  }, [_c('h4', [_vm._v("Account Password")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "two wide column"
  }, [_c('h4', [_vm._v("Payment")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui yellow segment",
    staticStyle: {
      "width": "90%",
      "clear": "both"
    }
  }, [_c('small', [_vm._v("\n                  Our payment processor is "), _c('a', {
    attrs: {
      "href": "https://stripe.com/about",
      "target": "_blank"
    }
  }, [_vm._v("Stripe")]), _vm._v(". All billing info, credit card numbers etc. go directly to them through their secure overlay.\n                  "), _c('br'), _vm._v("We never see or store anything - simply get a note from them that everything is good.\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui black deny button"
  }, [_vm._v("Close")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui basic modal",
    attrs: {
      "id": "deleteSellerAccountModal"
    }
  }, [_c('div', {
    staticClass: "ui icon header"
  }, [_c('i', {
    staticClass: "trash icon"
  }), _vm._v("Would you like to remove you seller account?")]), _vm._v(" "), _c('div', {
    staticClass: "ui center aligned container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h4', [_vm._v("Your data for this account will be permanently deleted, however you can re-add this account any time in the future.")]), _vm._v(" "), _c('p', [_vm._v("The removal process may take a few minutes.")])])]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui red basic cancel inverted button"
  }, [_c('i', {
    staticClass: "remove icon"
  }), _vm._v("No")]), _vm._v(" "), _c('div', {
    staticClass: "ui green ok inverted button"
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui basic modal",
    attrs: {
      "id": "deUserConfirmModal"
    }
  }, [_c('div', {
    staticClass: "ui icon header"
  }, [_c('i', {
    staticClass: "trash icon"
  }), _vm._v("Would you like to deactivate selected users?")]), _vm._v(" "), _c('div', {
    staticClass: "ui center aligned container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h4', [_vm._v("Your data for this account will be permanently deleted, however you can re-add this user any time in the future.")])])]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui red basic cancel inverted button"
  }, [_c('i', {
    staticClass: "remove icon"
  }), _vm._v("No")]), _vm._v(" "), _c('div', {
    staticClass: "ui green ok inverted button"
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui center aligned container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h4', [_vm._v("We appreciate you as a subscriber, we don't want to see you go.")]), _vm._v(" "), _c('p', [_vm._v("Here's 25% off for your next 6 months."), _c('br'), _vm._v("If you cancel, your subscription will stop auto renewing today and you will not be eligible for any discount offers."), _c('br'), _c('br')])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("If you still choose to cancel now, your subscription will stop auto renewing"), _c('br'), _vm._v("today and you will not be eligible for any future discount offers.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui basic cancel inverted button"
  }, [_c('i', {
    staticClass: "remove icon"
  }), _vm._v("Back to Account Settings")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui icon header"
  }, [_c('i', {
    staticClass: "play icon"
  }), _vm._v("Would you like to resume your subscription?")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui center aligned container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h4', [_vm._v("You may cancel your subscription any time in the future.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui red basic cancel inverted button"
  }, [_c('i', {
    staticClass: "remove icon"
  }), _vm._v("No")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui inverted cancel button"
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v("Close")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "ui horizontal divider header"
  }, [_c('i', {
    staticClass: "dollar sign icon"
  }), _vm._v("\n                  Current Balance\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bar"
  }, [_c('div', {
    staticClass: "progress"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "ui horizontal divider header"
  }, [_c('i', {
    staticClass: "university icon"
  }), _vm._v("\n                Bank Info\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui form"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("User")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4ba2f14c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/SettingsPage.vue
// module id = 768
// module chunks = 2